var $lTu3p$reactjsxruntime = require("react/jsx-runtime");
var $lTu3p$react = require("react");
var $lTu3p$classnames = require("classnames");
var $lTu3p$changecase = require("change-case");
var $lTu3p$reactslick = require("react-slick");
require("slick-carousel/slick/slick.css");
var $lTu3p$stashinvestreactassets = require("@stashinvest/react-assets");
var $lTu3p$formik = require("formik");
var $lTu3p$reacttextmask = require("react-text-mask");
var $lTu3p$textmaskaddonsdistcreateNumberMask = require("text-mask-addons/dist/createNumberMask");
var $lTu3p$datefns = require("date-fns");

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $8f0cabe9d646f134$exports = {};

$parcel$export($8f0cabe9d646f134$exports, "ButtonIcon", () => $7b54d821c3bd1415$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "ButtonLayout", () => $5c29081e7fefe80b$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "ButtonLink", () => $9cf8280dfc8967c4$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "ButtonStandard", () => $aa285ef5701ee664$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Badge", () => $c28a8a11c959dd9b$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Card", () => $42eef88816c1625d$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Carousel", () => $961368b1e467e620$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Checkbox", () => $9d80b25d1c39de98$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "ChipFilter", () => $1a2a8023a7645e85$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "ChipTag", () => $43e4c815475dc3b6$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Divider", () => $992792321d2e0f5b$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "LoaderIndeterminateCircular", () => $a0133489bd20f6e5$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Skeleton", () => $9a57ba2181e41d5d$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Radio", () => $9870ffb8643b14fb$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "StickyBoxBottom", () => $61c46fa35bb09f5f$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Toggle", () => $617525aee4f65198$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "CheckSelect", () => $8c7efe2f666cad3d$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "CheckSelectItem", () => $f7c6fef90cdc4b20$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "SelectionEntryButton", () => $840abbb2f61fda3f$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "ButtonChoice", () => $04a61b1b5a6a08b9$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "SearchEntry", () => $2277a79a78966356$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Toolbar", () => $1cb2318bc435a622$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "ButtonImage", () => $b410022bb5c44f17$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Text", () => $5bd3fa013367827b$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "RadioItem", () => $201c8ccc1e932409$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "AmountEntryXl", () => $c02d188a4317839c$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "AssistiveText", () => $972a082621bea3b5$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "ExpandItem", () => $e24eb9c6726cafe9$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "StickyBoxSheet", () => $af76199f3cd9f5b0$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "CheckboxItem", () => $1302f2f4097b68c6$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "ChipAction", () => $b19dbc5bde8e6bf8$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "ChipChoice", () => $ce0573c37119430a$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "Rail", () => $07724084de4503bf$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "NavChip", () => $b9c1f80609127d9a$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "DatePickerCalendar", () => $c4d0ab4f772c52a7$export$2e2bcd8739ae039);
$parcel$export($8f0cabe9d646f134$exports, "DateChip", () => $26fd68934b809475$export$2e2bcd8739ae039);




const $866f0fa8140c50df$export$18505e447a7bb2d5 = (base, otherClassNames)=>{
    return {
        base: base,
        ...otherClassNames ? otherClassNames.reduce((prev, current)=>{
            return {
                ...prev,
                [(0, $lTu3p$changecase.camelCase)(current)]: current
            };
        }, {}) : {}
    };
};
const $866f0fa8140c50df$export$5cc9199cd6cdbe3b = (classNames, props)=>{
    const classNameArray = [
        // 1st get base name from classNames e.g. 'sds-button-icon'
        classNames.base,
        ...props.className ? [
            props.className
        ] : [],
        // now generate classes from booleans or variants
        ...Object.entries(props).filter(([, propValue])=>propValue !== undefined).map(([propName, propValue])=>{
            const matchingClassname = classNames[propName];
            if (typeof propValue === "boolean" && matchingClassname) //e.g prop of isEnabled: true will output 'is-enabled'
            return [
                {
                    [matchingClassname]: propValue
                }
            ];
            else if (Object.values(classNames).filter((className)=>className.includes("-")).map((className)=>className.split("-")[0]).includes(propName)) {
                if (typeof propValue != "string") {
                    //Fix issue when propValue is a variant object
                    if (propValue.type && typeof propValue.type === "string") //variant objects typically have a variant.type
                    return [
                        `${propName}-${(0, $lTu3p$changecase.paramCase)(propValue.type)}`
                    ];
                    else return [
                        `${propName}-${(0, $lTu3p$changecase.paramCase)(typeof propValue)}`
                    ];
                }
                return [
                    `${propName}-${(0, $lTu3p$changecase.paramCase)(propValue)}`
                ];
            } else return [];
        }).flat(), 
    ];
    return classNameArray;
};


const $7b54d821c3bd1415$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-button-icon", [
    "is-enabled",
    "variant-tertiary",
    "variant-secondary",
    "variant-outline",
    "variant-inverse-tertiary",
    "variant-inverse-secondary",
    "variant-inverse-outline",
    "variant-primary",
    "variant-dim",
    "variant-brighten",
    "variant-highlight",
    "size-standard",
    "size-small",
    "size-logo", 
]);
const $7b54d821c3bd1415$var$variantToTokenMap = {
    "primary": "text-onPrimaryFixedVariant",
    "secondary": "text-onSurfaceVariant",
    "tertiary": "text-secondary",
    "outline": "text-secondary",
    "brighten": "text-backgroundFixedWhite",
    "highlight": "text-onSurface",
    "dim": "text-backgroundFixedBlack",
    "inverseSecondary": "text-inverseOnSurface",
    "inverseTertiary": "text-inverseOnSurface",
    "inverseOutline": "text-inverseOnSurface"
};
const $7b54d821c3bd1415$var$ButtonIcon = (props)=>{
    const { isEnabled: isEnabled = true , variant: variant = "tertiary" , altText: altText , size: size = "standard" , Icon: Icon , label: label ,  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("button", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($7b54d821c3bd1415$export$ce4ab0c55987d1ff, props)),
        disabled: !isEnabled,
        onClick: props.onClick,
        type: "button",
        title: altText,
        "aria-label": label,
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Icon, {
            size: size === "small" ? "2XS" : "XS",
            color: $7b54d821c3bd1415$var$variantToTokenMap[variant]
        })
    });
};
$7b54d821c3bd1415$var$ButtonIcon.defaultProps = {};
$7b54d821c3bd1415$var$ButtonIcon.displayName = "ButtonIcon";
var $7b54d821c3bd1415$export$2e2bcd8739ae039 = $7b54d821c3bd1415$var$ButtonIcon;







const $5c29081e7fefe80b$var$variantMap = {
    buttonStandard: "buttonLayout-buttonStandard",
    stackVertical: "buttonLayout-stackVertical",
    stackHorizontal: "buttonLayout-stackHorizontal"
};
const $5c29081e7fefe80b$var$ButtonLayout = (props)=>{
    const { variant: variant , children: children , className: className  } = props;
    const variantClassName = $5c29081e7fefe80b$var$variantMap[variant];
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))(variantClassName, className),
        children: children
    });
};
$5c29081e7fefe80b$var$ButtonLayout.displayName = "ButtonLayout";
var $5c29081e7fefe80b$export$2e2bcd8739ae039 = $5c29081e7fefe80b$var$ButtonLayout;







const $9cf8280dfc8967c4$var$ButtonLink = (props)=>{
    const { variant: variant = "primary" , hasUnderline: hasUnderline = true , isEnabled: isEnabled = true , ...rest } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("button", {
        ...rest,
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("button-link", variant, {
            hasUnderline: hasUnderline
        }, props.className),
        disabled: !isEnabled,
        onClick: props.onClick,
        children: props.children
    });
};
$9cf8280dfc8967c4$var$ButtonLink.displayName = "ButtonLink";
var $9cf8280dfc8967c4$export$2e2bcd8739ae039 = $9cf8280dfc8967c4$var$ButtonLink;










const $a0133489bd20f6e5$var$LoaderIndeterminateCircular = (props)=>{
    const { size: size = "large" , style: style = "solid" , fill: fill = "fill3"  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("loader-indeterminate-circular", size, style, props.className),
        style: {
            "--LoaderIndeterminateCircular-fill": `rgb(var(--${fill}))`
        },
        "aria-label": "Loading",
        role: "progressbar",
        "aria-busy": "true",
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("svg", {
                height: "48px",
                width: "48px",
                viewBox: "0 0 48 48",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("circle", {
                                cx: "24",
                                cy: "24",
                                r: "21"
                            }),
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("circle", {
                                cx: "24",
                                cy: "24",
                                r: "21"
                            }),
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("circle", {
                                cx: "24",
                                cy: "24",
                                r: "21"
                            })
                        ]
                    }),
                    props.style === "gradient" ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("linearGradient", {
                                id: "gradientSmall1",
                                x1: "50%",
                                x2: "50%",
                                y1: "100%",
                                y2: "0%",
                                children: [
                                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("stop", {
                                        offset: "0%",
                                        stopColor: "rgb(var(--onPrimaryContainer))"
                                    }),
                                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: "rgb(var(--primaryFixedDim))"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("linearGradient", {
                                id: "gradientSmall4",
                                x1: "50%",
                                x2: "50%",
                                y1: "100%",
                                y2: "0%",
                                children: [
                                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("stop", {
                                        offset: "0%",
                                        stopColor: "rgb(var(--success))"
                                    }),
                                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: "rgb(var(--accentFixedBright))"
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            props.text ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                children: props.text
            }) : null
        ]
    });
};
$a0133489bd20f6e5$var$LoaderIndeterminateCircular.displayName = "LoaderIndeterminateCircular";
var $a0133489bd20f6e5$export$2e2bcd8739ae039 = $a0133489bd20f6e5$var$LoaderIndeterminateCircular;


const $aa285ef5701ee664$var$loaderColorMap = {
    primary: "onPrimaryFixed",
    secondary: "onSurfaceVariant",
    tertiary: "secondary",
    outline: "onSurfaceVariant",
    inverseHighlight: "onSurface",
    inverseSecondary: "inverseOnSurface"
};
const $aa285ef5701ee664$var$ButtonStandard = (props)=>{
    const { loading: loading , variant: variant = "primary" , size: size = "large" , className: className , disabled: disabled , leftIcon: leftIcon , rightIcon: rightIcon , children: children , ...buttonProps } = props;
    const LeftIcon = leftIcon;
    const RightIcon = rightIcon;
    const loaderSize = "medium";
    const loaderFill = $aa285ef5701ee664$var$loaderColorMap[variant];
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("button", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("button-standard", variant, size, loading && "loading", className),
        disabled: disabled || loading,
        ...buttonProps,
        children: [
            LeftIcon ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(LeftIcon, {
                className: "leftIcon",
                size: "2XS"
            }) : null,
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                children: children
            }),
            RightIcon ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(RightIcon, {
                className: "rightIcon",
                size: "2XS"
            }) : null,
            loading && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: "loading-container",
                children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $a0133489bd20f6e5$export$2e2bcd8739ae039), {
                    size: loaderSize,
                    fill: loaderFill
                })
            })
        ]
    });
};
$aa285ef5701ee664$var$ButtonStandard.displayName = "ButtonStandard";
var $aa285ef5701ee664$export$2e2bcd8739ae039 = $aa285ef5701ee664$var$ButtonStandard;







let $3bd1b17765ddd9d5$export$18bf8be90b102439;
(function(BadgeVariant) {
    BadgeVariant["Neutral"] = "neutral";
    BadgeVariant["Warning"] = "warning";
    BadgeVariant["Fail"] = "fail";
    BadgeVariant["Success"] = "success";
    BadgeVariant["Brand"] = "brand";
})($3bd1b17765ddd9d5$export$18bf8be90b102439 || ($3bd1b17765ddd9d5$export$18bf8be90b102439 = {}));



const $c28a8a11c959dd9b$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-badge");
const $c28a8a11c959dd9b$var$Badge = (props)=>{
    const { variant: variant , children: children , className: className  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($c28a8a11c959dd9b$export$ce4ab0c55987d1ff, props), variant, className),
        children: children
    });
};
$c28a8a11c959dd9b$var$Badge.displayName = "Badge";
$c28a8a11c959dd9b$var$Badge.Variant = (0, $3bd1b17765ddd9d5$export$18bf8be90b102439);
var $c28a8a11c959dd9b$export$2e2bcd8739ae039 = $c28a8a11c959dd9b$var$Badge;







let $72ec68f6f23088dd$export$c32f46c9d34bc809;
(function(CardVariant) {
    CardVariant["Container"] = "container";
    CardVariant["Inverse"] = "inverse";
})($72ec68f6f23088dd$export$c32f46c9d34bc809 || ($72ec68f6f23088dd$export$c32f46c9d34bc809 = {}));


const $42eef88816c1625d$var$Card = (props)=>{
    const { variant: variant = (0, $72ec68f6f23088dd$export$c32f46c9d34bc809).Container , children: children , className: className , ...rest } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("section", {
        ...rest,
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("card", variant, className),
        children: children
    });
};
$42eef88816c1625d$var$Card.displayName = "Card";
$42eef88816c1625d$var$Card.Variant = (0, $72ec68f6f23088dd$export$c32f46c9d34bc809);
var $42eef88816c1625d$export$2e2bcd8739ae039 = $42eef88816c1625d$var$Card;









let $8a7ad39be61a4d7d$export$9ad75c3aaae5a571;
(function(CarouselVariant) {
    CarouselVariant["Background"] = "background";
    CarouselVariant["Container"] = "container";
    CarouselVariant["Inverse"] = "inverse";
})($8a7ad39be61a4d7d$export$9ad75c3aaae5a571 || ($8a7ad39be61a4d7d$export$9ad75c3aaae5a571 = {}));




const $961368b1e467e620$var$CustomArrow = (props)=>{
    const { Icon: Icon , variant: variant , ...slickProps } = props;
    const isEnabled = Boolean(props.onClick);
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        ...slickProps,
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
            variant: variant,
            Icon: Icon,
            isEnabled: isEnabled
        })
    });
};
const $961368b1e467e620$var$Carousel = (props)=>{
    const { children: children , onLargeGrid: onLargeGrid = false , hasGutter: hasGutter = true , hasBackground: hasBackground = true , variant: variant = (0, $8a7ad39be61a4d7d$export$9ad75c3aaae5a571).Background , className: className ,  } = props;
    const arrowVariant = variant === (0, $8a7ad39be61a4d7d$export$9ad75c3aaae5a571).Inverse ? "inverseSecondary" : "secondary";
    const carouselProps = {
        infinite: false,
        arrows: onLargeGrid,
        draggable: !onLargeGrid,
        slidesToScroll: 1,
        slidesToShow: 1,
        prevArrow: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)($961368b1e467e620$var$CustomArrow, {
            Icon: (0, $lTu3p$stashinvestreactassets.CaretLeftIcon),
            variant: arrowVariant
        }),
        nextArrow: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)($961368b1e467e620$var$CustomArrow, {
            Icon: (0, $lTu3p$stashinvestreactassets.CaretRightIcon),
            variant: arrowVariant
        }),
        dotsClass: (0, ($parcel$interopDefault($lTu3p$classnames)))("slick-dots", {
            hasBackground: hasBackground
        }),
        appendDots: (dots)=>/*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("ul", {
                children: dots
            }),
        customPaging: ()=>/*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$reactjsxruntime.Fragment), {}),
        dots: true
    };
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("carousel", {
            hasGutter: hasGutter
        }, variant, className),
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, ($parcel$interopDefault($lTu3p$reactslick))), {
            ...carouselProps,
            children: children
        })
    });
};
$961368b1e467e620$var$Carousel.displayName = "Carousel";
$961368b1e467e620$var$Carousel.Variant = (0, $8a7ad39be61a4d7d$export$9ad75c3aaae5a571);
var $961368b1e467e620$export$2e2bcd8739ae039 /* function CaretLeft() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.5302 18.9694C15.5999 19.039 15.6552 19.1218 15.6929 19.2128C15.7306 19.3039 15.75 19.4014 15.75 19.5C15.75 19.5985 15.7306 19.6961 15.6929 19.7872C15.6552 19.8782 15.5999 19.9609 15.5302 20.0306C15.4606 20.1003 15.3778 20.1556 15.2868 20.1933C15.1957 20.231 15.0982 20.2504 14.9996 20.2504C14.9011 20.2504 14.8035 20.231 14.7124 20.1933C14.6214 20.1556 14.5387 20.1003 14.469 20.0306L6.96899 12.5306C6.89926 12.461 6.84394 12.3782 6.80619 12.2872C6.76845 12.1961 6.74902 12.0986 6.74902 12C6.74902 11.9014 6.76845 11.8038 6.80619 11.7128C6.84394 11.6217 6.89926 11.539 6.96899 11.4694L14.469 3.96936C14.6097 3.82863 14.8006 3.74957 14.9996 3.74957C15.1986 3.74957 15.3895 3.82863 15.5302 3.96936C15.671 4.1101 15.75 4.30097 15.75 4.49999C15.75 4.69901 15.671 4.88988 15.5302 5.03061L8.55993 12L15.5302 18.9694Z"
				fill="currentColor"
			/>
		</svg>
	);
}
function CaretRight() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17.031 12.5306L9.53104 20.0306C9.46136 20.1003 9.37863 20.1556 9.28759 20.1933C9.19654 20.231 9.09896 20.2504 9.00042 20.2504C8.90187 20.2504 8.80429 20.231 8.71324 20.1933C8.6222 20.1556 8.53947 20.1003 8.46979 20.0306C8.40011 19.9609 8.34483 19.8782 8.30712 19.7872C8.26941 19.6961 8.25 19.5985 8.25 19.5C8.25 19.4014 8.26941 19.3039 8.30712 19.2128C8.34483 19.1218 8.40011 19.039 8.46979 18.9694L15.4401 12L8.46979 5.03061C8.32906 4.88988 8.25 4.69901 8.25 4.49999C8.25 4.30097 8.32906 4.1101 8.46979 3.96936C8.61052 3.82863 8.80139 3.74957 9.00042 3.74957C9.19944 3.74957 9.39031 3.82863 9.53104 3.96936L17.031 11.4694C17.1008 11.539 17.1561 11.6217 17.1938 11.7128C17.2316 11.8038 17.251 11.9014 17.251 12C17.251 12.0986 17.2316 12.1961 17.1938 12.2872C17.1561 12.3782 17.1008 12.461 17.031 12.5306Z"
				fill="currentColor"
			/>
		</svg>
	);
} */  = $961368b1e467e620$var$Carousel;








const $9d80b25d1c39de98$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-checkbox", [
    "checkbox-container",
    "header",
    "body", 
]);
const $9d80b25d1c39de98$var$Checkbox = (props)=>{
    const { children: children , checked: checked , className: className , defaultChecked: defaultChecked , describedby: describedby , isEnabled: isEnabled = true , labelledby: labelledby , name: name , onChange: onChange ,  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("label", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($9d80b25d1c39de98$export$ce4ab0c55987d1ff, props), className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: $9d80b25d1c39de98$export$ce4ab0c55987d1ff.checkboxContainer,
                children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("input", {
                    type: "checkbox",
                    "aria-labelledby": labelledby,
                    "aria-describedby": describedby,
                    checked: checked,
                    defaultChecked: defaultChecked,
                    name: name,
                    disabled: !isEnabled,
                    onChange: onChange
                })
            }),
            children,
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("br", {})
        ]
    });
};
$9d80b25d1c39de98$var$Checkbox.displayName = "Checkbox";
var $9d80b25d1c39de98$export$2e2bcd8739ae039 = $9d80b25d1c39de98$var$Checkbox;







const $1a2a8023a7645e85$var$ChipFilter = (props)=>{
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("label", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("chip-filter", props.className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("input", {
                type: "checkbox",
                checked: props.checked,
                name: props.name,
                onChange: props.onChange
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                "data-count": props.count,
                children: props.children
            })
        ]
    });
};
$1a2a8023a7645e85$var$ChipFilter.displayName = "ChipFilter";
var $1a2a8023a7645e85$export$2e2bcd8739ae039 = $1a2a8023a7645e85$var$ChipFilter;







const $43e4c815475dc3b6$var$ChipTag = (props)=>{
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("label", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("chip-tag", props.className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("input", {
                type: "checkbox",
                checked: props.checked,
                name: props.name,
                onChange: props.onChange
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                children: props.children
            })
        ]
    });
};
$43e4c815475dc3b6$var$ChipTag.displayName = "ChipTag";
var $43e4c815475dc3b6$export$2e2bcd8739ae039 = $43e4c815475dc3b6$var$ChipTag;







let $376c63c6ba83428f$export$54185d2eeb5d1a94;
(function(DividerOrientation) {
    DividerOrientation["Horizontal"] = "horizontal";
    DividerOrientation["Vertical"] = "vertical";
})($376c63c6ba83428f$export$54185d2eeb5d1a94 || ($376c63c6ba83428f$export$54185d2eeb5d1a94 = {}));


const $992792321d2e0f5b$var$Divider = (props)=>{
    const className = props.orientation === (0, $376c63c6ba83428f$export$54185d2eeb5d1a94).Vertical ? "divider-vertical" : "divider-horizontal";
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("hr", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))(className, props.className)
    });
};
var $992792321d2e0f5b$export$2e2bcd8739ae039 = $992792321d2e0f5b$var$Divider;











const $9a57ba2181e41d5d$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-skeleton");
const $9a57ba2181e41d5d$var$Skeleton = (props)=>{
    const { className: className  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($9a57ba2181e41d5d$export$ce4ab0c55987d1ff, props), className),
        children: "\xa0"
    });
};
$9a57ba2181e41d5d$var$Skeleton.displayName = "Skeleton";
var $9a57ba2181e41d5d$export$2e2bcd8739ae039 = $9a57ba2181e41d5d$var$Skeleton;








const $9870ffb8643b14fb$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("radio", [
    "radio-container",
    "header",
    "body"
]);
const $9870ffb8643b14fb$var$Radio = (props)=>{
    const { children: children , className: className , checked: checked , isEnabled: isEnabled = true , defaultChecked: defaultChecked , name: name , labelledby: labelledby , describedby: describedby , onChange: onChange ,  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("label", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($9870ffb8643b14fb$export$ce4ab0c55987d1ff, props), className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: (0, ($parcel$interopDefault($lTu3p$classnames)))($9870ffb8643b14fb$export$ce4ab0c55987d1ff.radioContainer),
                children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("input", {
                    type: "radio",
                    "aria-labelledby": labelledby,
                    "aria-describedby": describedby,
                    checked: checked,
                    defaultChecked: defaultChecked,
                    name: name,
                    disabled: !isEnabled,
                    onChange: onChange
                })
            }),
            children
        ]
    });
};
$9870ffb8643b14fb$var$Radio.displayName = "Radio";
var $9870ffb8643b14fb$export$2e2bcd8739ae039 = $9870ffb8643b14fb$var$Radio;








const $61c46fa35bb09f5f$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-stickyBoxBottom", [
    "fade",
    "inner",
    "solid-background",
    "legal-layout",
    "button", 
]);
const $61c46fa35bb09f5f$var$StickyBoxBottom = (props)=>{
    const { className: className , legalLayout: legalLayout , buttonLayout: buttonLayout , bottom: bottom = 0 , zIndex: zIndex = 0 , background: background = "background" ,  } = props;
    const containerRef = (0, $lTu3p$react.useRef)(null);
    const [height, setHeight] = (0, $lTu3p$react.useState)(0);
    (0, $lTu3p$react.useEffect)(()=>{
        if (!containerRef?.current?.clientHeight) return;
        setHeight(containerRef?.current?.clientHeight);
    }, [
        containerRef?.current?.clientHeight
    ]);
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($61c46fa35bb09f5f$export$ce4ab0c55987d1ff, props), className),
        style: {
            height: height
        },
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
            className: $61c46fa35bb09f5f$export$ce4ab0c55987d1ff.inner,
            style: {
                bottom: bottom,
                zIndex: zIndex
            },
            ref: containerRef,
            children: [
                /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                    className: (0, ($parcel$interopDefault($lTu3p$classnames)))($61c46fa35bb09f5f$export$ce4ab0c55987d1ff.fade),
                    style: {
                        background: `linear-gradient(0deg,rgb(var(--${background})) 0%,transparent 100%)`
                    }
                }),
                /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                    className: (0, ($parcel$interopDefault($lTu3p$classnames)))($61c46fa35bb09f5f$export$ce4ab0c55987d1ff.solidBackground, `bg-${background}`),
                    children: [
                        legalLayout && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                            className: $61c46fa35bb09f5f$export$ce4ab0c55987d1ff.legalLayout,
                            children: legalLayout
                        }),
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                            className: $61c46fa35bb09f5f$export$ce4ab0c55987d1ff.button,
                            children: buttonLayout
                        })
                    ]
                })
            ]
        })
    });
};
$61c46fa35bb09f5f$var$StickyBoxBottom.displayName = "StickyBoxBottom";
var $61c46fa35bb09f5f$export$2e2bcd8739ae039 = $61c46fa35bb09f5f$var$StickyBoxBottom;







const $617525aee4f65198$var$Toggle = (props)=>{
    const { checked: checked , children: children , className: className , defaultChecked: defaultChecked , describedby: describedby , isEnabled: isEnabled = true , labelledby: labelledby , onChange: onChange ,  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("label", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("toggle", className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("input", {
                type: "checkbox",
                "aria-labelledby": labelledby,
                "aria-describedby": describedby,
                checked: checked,
                defaultChecked: defaultChecked,
                disabled: !isEnabled,
                onChange: onChange
            }),
            children
        ]
    });
};
$617525aee4f65198$var$Toggle.displayName = "Toggle";
var $617525aee4f65198$export$2e2bcd8739ae039 = $617525aee4f65198$var$Toggle;




var $c60dcc067ac8bcae$exports = {};

$parcel$export($c60dcc067ac8bcae$exports, "FloatingSheet", () => $656976ba4bfa361e$export$2e2bcd8739ae039);





function $2c27ad09a80ee587$export$ed69ed1b39dc6e43({ onClose: onClose , animationTimeout: animationTimeout  }) {
    const [isClosing, setClosing] = (0, $lTu3p$react.useState)(false);
    function closeSheet() {
        setClosing(true);
        setTimeout(()=>{
            onClose();
        }, animationTimeout);
    }
    return {
        isClosing: isClosing,
        closeSheet: closeSheet
    };
}


const $656976ba4bfa361e$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-floating-sheet", [
    "floating-sheet-overlay",
    "floating-sheet-container",
    "floating-sheet-content", 
]);
const $656976ba4bfa361e$var$FloatingSheet = (props)=>{
    const { onClose: onClose , className: className , toolbar: toolbar , children: children , labelledBy: labelledBy , isDismissable: isDismissable = true ,  } = props;
    const { isClosing: isClosing , closeSheet: closeSheet  } = (0, $2c27ad09a80ee587$export$ed69ed1b39dc6e43)({
        onClose: onClose,
        animationTimeout: 125
    });
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($656976ba4bfa361e$export$ce4ab0c55987d1ff, props), className, {
            isClosing: isClosing
        }),
        // aria-hidden="true"
        "aria-labelledby": labelledBy,
        role: "dialog",
        "data-testid": props["data-testid"],
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: $656976ba4bfa361e$export$ce4ab0c55987d1ff.floatingSheetOverlay,
                onClick: isDismissable ? closeSheet : undefined
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: $656976ba4bfa361e$export$ce4ab0c55987d1ff.floatingSheetContainer,
                role: "document",
                children: [
                    toolbar,
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        className: $656976ba4bfa361e$export$ce4ab0c55987d1ff.floatingSheetContent,
                        children: children
                    })
                ]
            })
        ]
    });
};
$656976ba4bfa361e$var$FloatingSheet.displayName = "FloatingSheet";
var $656976ba4bfa361e$export$2e2bcd8739ae039 = $656976ba4bfa361e$var$FloatingSheet;


var $4968c1eba1994cc6$exports = {};


$parcel$exportWildcard($c60dcc067ac8bcae$exports, $4968c1eba1994cc6$exports);


var $82b4fea781088685$exports = {};

$parcel$export($82b4fea781088685$exports, "FullSheet", () => $e55197579b157703$export$2e2bcd8739ae039);






const $af76199f3cd9f5b0$var$StickyBoxSheet = (props)=>{
    const { legalLayout: legalLayout , buttonLayout: buttonLayout  } = props;
    const containerRef = (0, $lTu3p$react.useRef)(null);
    const [height, setHeight] = (0, $lTu3p$react.useState)(0);
    (0, $lTu3p$react.useEffect)(()=>{
        if (!containerRef?.current?.clientHeight) return;
        setHeight(containerRef?.current?.clientHeight);
    }, [
        containerRef?.current?.clientHeight
    ]);
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        style: {
            height: height
        },
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
            className: "absolute left-0 right-0 bottom-0 flex flex-col gap-contentSmall py-contentSmall bg-containerLow",
            ref: containerRef,
            children: [
                legalLayout && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                    className: "px-contentMedium",
                    children: legalLayout
                }),
                /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                    className: "py-contentXS",
                    children: buttonLayout
                })
            ]
        })
    });
};
var $af76199f3cd9f5b0$export$2e2bcd8739ae039 = $af76199f3cd9f5b0$var$StickyBoxSheet;


const $e55197579b157703$var$FullSheet = (props)=>{
    const { navLayout: navLayout , mainLayout: mainLayout , legalLayout: legalLayout , buttonLayout: buttonLayout , onClose: onClose , isDismissable: isDismissable = true ,  } = props;
    const { isClosing: isClosing , closeSheet: closeSheet  } = (0, $2c27ad09a80ee587$export$ed69ed1b39dc6e43)({
        onClose: onClose,
        animationTimeout: 125
    });
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("full-sheet", {
            isClosing: isClosing
        }),
        // aria-hidden="true"
        // aria-labelledby="my-dialog-title"
        "data-testid": props["data-testid"],
        role: "dialog",
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: "full-sheet-overlay",
                onClick: isDismissable ? closeSheet : undefined
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: "full-sheet-content",
                role: "document",
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        className: "full-sheet-nav",
                        children: navLayout?.({
                            closeSheet: closeSheet
                        })
                    }),
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                        className: "full-sheet-main",
                        children: [
                            mainLayout,
                            (!!legalLayout || !!buttonLayout) && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $af76199f3cd9f5b0$export$2e2bcd8739ae039), {
                                legalLayout: legalLayout,
                                buttonLayout: buttonLayout && buttonLayout({
                                    closeSheet: closeSheet
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$e55197579b157703$var$FullSheet.displayName = "FullSheet";
var $e55197579b157703$export$2e2bcd8739ae039 = $e55197579b157703$var$FullSheet;




var $0b55ea58065af7ac$exports = {};

$parcel$export($0b55ea58065af7ac$exports, "PartialSheet", () => $4e62b14169024d2d$export$2e2bcd8739ae039);







const $4e62b14169024d2d$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-partial-sheet", [
    "partial-sheet-overlay",
    "partial-sheet-container",
    "partial-sheet-nav",
    "partial-sheet-content",
    "partial-sheet-bottom", 
]);
const $4e62b14169024d2d$var$mapPaddingToClassName = {
    none: "p-contentNone",
    small: "py-contentXS px-contentSmall",
    medium: "py-contentSmall px-contentMedium"
};
const $4e62b14169024d2d$var$PartialSheet = (props)=>{
    const { children: children , StickyBoxBottom: StickyBoxBottom , onClose: onClose = ()=>{} , className: className , contentPadding: contentPadding = "medium" , isDismissable: isDismissable = true ,  } = props;
    const { isClosing: isClosing , closeSheet: closeSheet  } = (0, $2c27ad09a80ee587$export$ed69ed1b39dc6e43)({
        onClose: onClose,
        animationTimeout: 200
    });
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($4e62b14169024d2d$export$ce4ab0c55987d1ff, props), className, {
            isClosing: isClosing
        }),
        "data-testid": props["data-testid"],
        role: "dialog",
        "aria-labelledby": props.labelledBy,
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: $4e62b14169024d2d$export$ce4ab0c55987d1ff.partialSheetOverlay,
                onClick: isDismissable ? closeSheet : undefined
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: $4e62b14169024d2d$export$ce4ab0c55987d1ff.partialSheetContainer,
                role: "document",
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        className: $4e62b14169024d2d$export$ce4ab0c55987d1ff.partialSheetNav,
                        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                            Icon: (0, $lTu3p$stashinvestreactassets.XIcon),
                            onClick: closeSheet,
                            label: "Close sheet"
                        })
                    }),
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        className: (0, ($parcel$interopDefault($lTu3p$classnames)))($4e62b14169024d2d$export$ce4ab0c55987d1ff.partialSheetContent, $4e62b14169024d2d$var$mapPaddingToClassName[contentPadding]),
                        children: children
                    }),
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        className: $4e62b14169024d2d$export$ce4ab0c55987d1ff.partialSheetBottom,
                        children: StickyBoxBottom
                    })
                ]
            })
        ]
    });
};
$4e62b14169024d2d$var$PartialSheet.displayName = "PartialSheet";
var $4e62b14169024d2d$export$2e2bcd8739ae039 = $4e62b14169024d2d$var$PartialSheet;




var $78f617b04b41d203$exports = {};

$parcel$export($78f617b04b41d203$exports, "ToggleItem", () => $e6474fee333b7e09$export$2e2bcd8739ae039);




function $e6474fee333b7e09$var$ToggleItem(props) {
    const { className: className , children: children , ...rest } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("toggle-item", className),
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $617525aee4f65198$export$2e2bcd8739ae039), {
            ...rest,
            children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                children: children
            })
        })
    });
}
$e6474fee333b7e09$var$ToggleItem.displayName = "ToggleItem";
var $e6474fee333b7e09$export$2e2bcd8739ae039 = $e6474fee333b7e09$var$ToggleItem;




var $7d629b70e7261af1$exports = {};

$parcel$export($7d629b70e7261af1$exports, "InformationItem", () => $2d7b6089267e3479$export$2e2bcd8739ae039);




const $2d7b6089267e3479$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-information-item", [
    "variant-icon",
    "variant-avatar",
    "variant-text",
    "left",
    "top",
    "right",
    "bottom",
    "avatar",
    "icon",
    "icon-text", 
]);
const $2d7b6089267e3479$var$InformationItem = (props)=>{
    const { className: className , variant: variant  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($2d7b6089267e3479$export$ce4ab0c55987d1ff, props), className),
        children: variant.type === "icon" ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)((0, $lTu3p$reactjsxruntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                    className: $2d7b6089267e3479$export$ce4ab0c55987d1ff.icon,
                    children: variant.icon
                }),
                /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                    className: $2d7b6089267e3479$export$ce4ab0c55987d1ff.iconText,
                    children: variant.text
                })
            ]
        }) : /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)((0, $lTu3p$reactjsxruntime.Fragment), {
            children: [
                variant.type === "avatar" && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                    className: $2d7b6089267e3479$export$ce4ab0c55987d1ff.avatar,
                    children: variant.avatar
                }),
                /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                    className: $2d7b6089267e3479$export$ce4ab0c55987d1ff.left,
                    children: [
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                            className: $2d7b6089267e3479$export$ce4ab0c55987d1ff.top,
                            children: variant.topLeftText
                        }),
                        variant.bottomLeftText && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                            className: $2d7b6089267e3479$export$ce4ab0c55987d1ff.bottom,
                            children: variant.bottomLeftText
                        })
                    ]
                }),
                (variant.topRightText || variant.bottomRightText) && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                    className: $2d7b6089267e3479$export$ce4ab0c55987d1ff.right,
                    children: [
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                            className: $2d7b6089267e3479$export$ce4ab0c55987d1ff.top,
                            children: variant.topRightText
                        }),
                        variant.bottomRightText && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                            className: $2d7b6089267e3479$export$ce4ab0c55987d1ff.bottom,
                            children: variant.bottomRightText
                        })
                    ]
                })
            ]
        })
    });
};
$2d7b6089267e3479$var$InformationItem.displayName = "InformationItem";
var $2d7b6089267e3479$export$2e2bcd8739ae039 = $2d7b6089267e3479$var$InformationItem;




var $f31f8d60604045c3$exports = {};

$parcel$export($f31f8d60604045c3$exports, "LinkItem", () => $dd9677d7ac33ba37$export$2e2bcd8739ae039);





const $dd9677d7ac33ba37$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-link-item", [
    "variant-caret",
    "variant-avatar-caret",
    "variant-info-body",
    "variant-info-table",
    "variant-avatar",
    "left-icon",
    "avatar",
    "text",
    "left",
    "left-column",
    "right",
    "right-column",
    "top",
    "bottom",
    "slot1",
    "slot2",
    "right-icon",
    "is-disabled", 
]);
const $dd9677d7ac33ba37$var$LinkItem = (props)=>{
    const { variant: variant , altText: altText , onClick: onClick , href: href , isEnabled: isEnabled = true  } = props;
    const fullClassName = (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($dd9677d7ac33ba37$export$ce4ab0c55987d1ff, props), {
        [$dd9677d7ac33ba37$export$ce4ab0c55987d1ff.isDisabled]: !isEnabled
    });
    const avatarItem = variant.type === "avatar" || variant.type === "avatarCaret";
    let Icon;
    if (variant.type === "caret") Icon = variant.Icon;
    const Inner = /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)((0, $lTu3p$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.leftColumn,
                children: [
                    (variant.type === "caret" && variant.Icon || avatarItem) && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                        className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.leftIcon,
                        children: [
                            variant.type === "caret" && Icon && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Icon, {
                                size: "XS",
                                color: variant.iconColor
                            }),
                            avatarItem && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                                className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.avatar,
                                children: variant.avatar
                            })
                        ]
                    }),
                    (variant.type === "caret" || variant.type === "infoBody") && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                        className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.text,
                        children: [
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                                className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.slot1,
                                children: variant.title
                            }),
                            variant.type === "caret" && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                                className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.slot2,
                                children: variant.caption
                            })
                        ]
                    }),
                    avatarItem && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$reactjsxruntime.Fragment), {
                        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                            className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.left,
                            children: (variant.bottomLeftText || variant.topLeftText) && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)((0, $lTu3p$reactjsxruntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                                        className: "top",
                                        children: variant.topLeftText
                                    }),
                                    variant.bottomLeftText && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                                        className: "bottom",
                                        children: variant.bottomLeftText
                                    })
                                ]
                            })
                        })
                    }),
                    variant.type === "infoTable" && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$reactjsxruntime.Fragment), {
                        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                            className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.slot1,
                            children: variant.title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.rightColumn,
                children: [
                    variant.type === "infoTable" && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$reactjsxruntime.Fragment), {
                        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                            className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.slot2,
                            children: variant.detail
                        })
                    }),
                    variant.type !== "avatar" && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                        className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.rightIcon,
                        children: [
                            (variant.type === "caret" || variant.type === "avatarCaret") && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.CaretRightIcon), {
                                size: "XS"
                            }),
                            (variant.type === "infoBody" || variant.type === "infoTable") && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.InfoIcon), {
                                size: "XS"
                            })
                        ]
                    }),
                    variant.type === "avatar" && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$reactjsxruntime.Fragment), {
                        children: (variant.bottomRightText || variant.topRightText) && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                            className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.right,
                            children: [
                                /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                                    className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.top,
                                    children: variant.topRightText
                                }),
                                variant.bottomRightText && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                                    className: $dd9677d7ac33ba37$export$ce4ab0c55987d1ff.bottom,
                                    children: variant.bottomRightText
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
    //TODO: Decide how we handle SPA links & make this into a generic 'clickable' HOC  / Wrapper
    return !href ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("button", {
        className: fullClassName,
        onClick: onClick,
        title: altText,
        disabled: !isEnabled,
        children: Inner
    }) : /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("a", {
        className: fullClassName,
        href: href,
        onClick: onClick,
        title: altText,
        children: Inner
    });
};
$dd9677d7ac33ba37$var$LinkItem.displayName = "LinkItem";
var $dd9677d7ac33ba37$export$2e2bcd8739ae039 = $dd9677d7ac33ba37$var$LinkItem;




var $4dde96c5bace9e4c$exports = {};

$parcel$export($4dde96c5bace9e4c$exports, "NavIcon", () => $60c53d86fc4777eb$export$2e2bcd8739ae039);



function $60c53d86fc4777eb$var$NavIcon(props) {
    const { iconLeft: iconLeft , iconRight: iconRight , text: text , className: className  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("navIcon", className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                children: iconLeft
            }),
            text && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                children: text
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                children: iconRight
            })
        ]
    });
}
$60c53d86fc4777eb$var$NavIcon.displayName = "NavIcon";
var $60c53d86fc4777eb$export$2e2bcd8739ae039 = $60c53d86fc4777eb$var$NavIcon;




var $730b44557d7ae177$exports = {};

$parcel$export($730b44557d7ae177$exports, "FormikTextEntryStandard", () => $730b44557d7ae177$export$a417c04fb3855a96);
$parcel$export($730b44557d7ae177$exports, "TextEntryStandard", () => $ff04297a8f0ff47d$export$2e2bcd8739ae039);



const $824ac643efa79f45$var$isUntrimmed = (str)=>/^\s|\s$/.test(str);
function $824ac643efa79f45$export$3d9d5005a7ef589(Component) {
    return function wrappedFormikComponent(props) {
        return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$formik.Field), {
            ...props,
            children: ({ field: field , form: form  })=>{
                function isInputDirty(name) {
                    // from https://github.com/jaredpalmer/formik/issues/3612
                    const boolean = form.getFieldMeta(name).value === form.getFieldMeta(name).initialValue;
                    return !boolean;
                }
                const wrappedOnChange = (e, ...args)=>{
                    // All browsers will trim email inputs except Firefox.
                    // Trim whitespace for browser consistency
                    if (props.type === "email" && $824ac643efa79f45$var$isUntrimmed(e.target.value) && props.name) return form.setFieldValue(props.name, e.target.value.trim());
                    if (props.onChange) props.onChange(e, ...args);
                    field.onChange(e, ...args);
                };
                const error = (form.submitCount > 0 || isInputDirty(field.name)) && form.errors[field.name];
                return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Component, {
                    ...props,
                    ...field,
                    onChange: wrappedOnChange,
                    error: error
                });
            }
        });
    };
}









const $00debe9b1e22cfd5$var$defaultMaskOptions = {
    prefix: "$ ",
    suffix: "",
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ",",
    allowDecimal: true,
    decimalSymbol: ".",
    decimalLimit: 2,
    integerLimit: 12,
    allowNegative: false,
    allowLeadingZeroes: false
};
const $00debe9b1e22cfd5$var$dict = {
    CVV: [
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ],
    SSN: [
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ],
    phoneNumber: [
        "+",
        "1",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/, 
    ],
    creditCard: [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/, 
    ],
    currency: (0, ($parcel$interopDefault($lTu3p$textmaskaddonsdistcreateNumberMask)))($00debe9b1e22cfd5$var$defaultMaskOptions),
    dateOfBirth: [
        /\d/,
        /\d/,
        "/",
        /\d/,
        /\d/,
        "/",
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ]
};
const $00debe9b1e22cfd5$var$maskDict = (mask, currencyMaskOptions = {})=>{
    if (mask === "currency") return (0, ($parcel$interopDefault($lTu3p$textmaskaddonsdistcreateNumberMask)))({
        ...$00debe9b1e22cfd5$var$defaultMaskOptions,
        ...currencyMaskOptions
    });
    return $00debe9b1e22cfd5$var$dict[mask];
};
var $00debe9b1e22cfd5$export$2e2bcd8739ae039 = $00debe9b1e22cfd5$var$maskDict;


const $ff04297a8f0ff47d$var$TextEntryStandard = (props)=>{
    const { className: className , disabled: disabled , error: error , label: label , assistiveText: assistiveText , fieldType: fieldType = "simple" , inputType: inputType , type: type = "text" , autoComplete: autoComplete = "off" , value: value , onFocus: onFocus , onBlur: onBlur , onConceal: onConceal , currencyMaskOptions: currencyMaskOptions , ...inputProps } = props;
    // determine input component (masked or regular)
    const inputMask = inputType ? (0, $00debe9b1e22cfd5$export$2e2bcd8739ae039)(inputType, currencyMaskOptions) : undefined;
    // determining if input has any value
    const inputRef = (0, $lTu3p$react.useRef)(null);
    const inputValue = value || (inputMask ? inputRef.current?.inputElement?.value : inputRef.current?.value);
    // determine if input is focused
    const [isFocused, setFocused] = (0, $lTu3p$react.useState)(Boolean(inputValue));
    function handleFocus(event) {
        setFocused(true);
        onFocus?.(event);
    }
    function handleBlur(event) {
        setFocused(false);
        onBlur?.(event);
    }
    // determine if label should be shrunken or expanded
    const expandLabel = !(isFocused || inputValue || props.placeholder || type === "date");
    // determine if input conceal icon should render
    const isSensitiveField = !disabled && (fieldType === "sensitive" || type === "password");
    // determine if input should be concealed or not
    const [concealInput, setConcealInput] = (0, $lTu3p$react.useState)(isSensitiveField);
    function handleConcealClick() {
        setConcealInput(!concealInput);
        if (typeof onConceal === "function") onConceal(!concealInput);
    }
    const commonInputProps = {
        type: isSensitiveField ? concealInput ? "password" : "text" : type,
        disabled: disabled,
        value: value,
        onFocus: handleFocus,
        onBlur: handleBlur,
        autoComplete: autoComplete,
        ...inputProps
    };
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("text-entry-standard", className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("label", {
                className: (0, ($parcel$interopDefault($lTu3p$classnames)))({
                    disabled: disabled,
                    hasError: error,
                    empty: expandLabel,
                    sensitive: isSensitiveField
                }),
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                        children: label
                    }),
                    inputMask ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, ($parcel$interopDefault($lTu3p$reacttextmask))), {
                        ref: inputRef,
                        ...commonInputProps,
                        showMask: true,
                        guide: false,
                        mask: inputMask
                    }) : /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("input", {
                        ref: inputRef,
                        ...commonInputProps
                    }),
                    Boolean(isSensitiveField) ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                        onClick: handleConcealClick,
                        // label={concealInput ? 'reveal password' : 'hide password'}
                        Icon: concealInput ? (0, $lTu3p$stashinvestreactassets.EyeIcon) : (0, $lTu3p$stashinvestreactassets.EyeSlashIcon)
                    }) : null
                ]
            }),
            error ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                className: "mt-content2XS captionMediumStandard text-error",
                children: error
            }) : assistiveText ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                className: "mt-content2XS captionMediumStandard text-onSurface",
                children: assistiveText
            }) : null
        ]
    });
};
$ff04297a8f0ff47d$var$TextEntryStandard.displayName = "TextEntryStandard";
var $ff04297a8f0ff47d$export$2e2bcd8739ae039 = $ff04297a8f0ff47d$var$TextEntryStandard;


const $730b44557d7ae177$export$a417c04fb3855a96 = (0, $824ac643efa79f45$export$3d9d5005a7ef589)((0, $ff04297a8f0ff47d$export$2e2bcd8739ae039));


var $7d4e8855bbfad588$exports = {};

$parcel$export($7d4e8855bbfad588$exports, "OneString", () => $6b735e2037766ab0$export$2e2bcd8739ae039);



var $44e73df06a2b599b$exports = {};

$parcel$export($44e73df06a2b599b$exports, "OneStringColor", () => $44e73df06a2b599b$export$9eb3b2e2bd9d0322);
$parcel$export($44e73df06a2b599b$exports, "OneStringTextStyle", () => $44e73df06a2b599b$export$45a9da76fb9a91c5);
$parcel$export($44e73df06a2b599b$exports, "OneStringAlignment", () => $44e73df06a2b599b$export$16dd9c6921e13908);
let $44e73df06a2b599b$export$9eb3b2e2bd9d0322;
(function(OneStringColor) {
    OneStringColor["lead"] = "lead";
    OneStringColor["supporting"] = "supporting";
    OneStringColor["inverse"] = "inverse";
})($44e73df06a2b599b$export$9eb3b2e2bd9d0322 || ($44e73df06a2b599b$export$9eb3b2e2bd9d0322 = {}));
let $44e73df06a2b599b$export$45a9da76fb9a91c5;
(function(OneStringTextStyle) {
    OneStringTextStyle["displayXL"] = "displayXL";
    OneStringTextStyle["displayLarge"] = "displayLarge";
    OneStringTextStyle["header2XL"] = "header2XL";
    OneStringTextStyle["headerXL"] = "headerXL";
    OneStringTextStyle["headerLarge"] = "headerLarge";
    OneStringTextStyle["headerMedium"] = "headerMedium";
    OneStringTextStyle["headerSmall"] = "headerSmall";
    OneStringTextStyle["headerXS"] = "headerXS";
    OneStringTextStyle["header2XS"] = "header2XS";
    OneStringTextStyle["bodyXLStandard"] = "bodyXLStandard";
    OneStringTextStyle["bodyXLEmphasize"] = "bodyXLEmphasize";
    OneStringTextStyle["bodyXLLink"] = "bodyXLLink";
    OneStringTextStyle["bodyLargeStandard"] = "bodyLargeStandard";
    OneStringTextStyle["bodyLargeEmphasize"] = "bodyLargeEmphasize";
    OneStringTextStyle["bodyLargeLink"] = "bodyLargeLink";
    OneStringTextStyle["bodyMediumStandard"] = "bodyMediumStandard";
    OneStringTextStyle["bodyMediumEmphasize"] = "bodyMediumEmphasize";
    OneStringTextStyle["bodyMediumLink"] = "bodyMediumLink";
    OneStringTextStyle["bodySmallStandard"] = "bodySmallStandard";
    OneStringTextStyle["bodySmallEmphasize"] = "bodySmallEmphasize";
    OneStringTextStyle["bodySmallLink"] = "bodySmallLink";
    OneStringTextStyle["labelXLStandard"] = "labelXLStandard";
    OneStringTextStyle["labelXLEmphasize"] = "labelXLEmphasize";
    OneStringTextStyle["labelLargeStandard"] = "labelLargeStandard";
    OneStringTextStyle["labelLargeEmphasize"] = "labelLargeEmphasize";
    OneStringTextStyle["labelMediumStandard"] = "labelMediumStandard";
    OneStringTextStyle["labelMediumEmphasize"] = "labelMediumEmphasize";
    OneStringTextStyle["labelSmallStandard"] = "labelSmallStandard";
    OneStringTextStyle["labelSmallEmphasize"] = "labelSmallEmphasize";
    OneStringTextStyle["labelXSStandard"] = "labelXSStandard";
    OneStringTextStyle["labelXSEmphasize"] = "labelXSEmphasize";
    OneStringTextStyle["captionLargeStandard"] = "captionLargeStandard";
    OneStringTextStyle["captionLargeEmphasize"] = "captionLargeEmphasize";
    OneStringTextStyle["captionMediumStandard"] = "captionMediumStandard";
    OneStringTextStyle["captionMediumEmphasize"] = "captionMediumEmphasize";
    OneStringTextStyle["captionSmallStandard"] = "captionSmallStandard";
    OneStringTextStyle["captionSmallEmphasize"] = "captionSmallEmphasize";
    OneStringTextStyle["numeralDisplayXL"] = "numeralDisplayXL";
    OneStringTextStyle["numeralDisplayLarge"] = "numeralDisplayLarge";
    OneStringTextStyle["numeralHeader2XL"] = "numeralHeader2XL";
    OneStringTextStyle["numeralHeaderXL"] = "numeralHeaderXL";
    OneStringTextStyle["numeralHeaderLarge"] = "numeralHeaderLarge";
    OneStringTextStyle["numeralHeaderMedium"] = "numeralHeaderMedium";
    OneStringTextStyle["numeralHeaderSmall"] = "numeralHeaderSmall";
    OneStringTextStyle["numeralHeaderXS"] = "numeralHeaderXS";
    OneStringTextStyle["numeralHeader2XS"] = "numeralHeader2XS";
    OneStringTextStyle["numeralBodyLargeStandard"] = "numeralBodyLargeStandard";
    OneStringTextStyle["numeralBodyLargeEmphasize"] = "numeralBodyLargeEmphasize";
    OneStringTextStyle["numeralBodyMediumStandard"] = "numeralBodyMediumStandard";
    OneStringTextStyle["numeralBodyMediumEmphasize"] = "numeralBodyMediumEmphasize";
    OneStringTextStyle["numeralBodySmallStandard"] = "numeralBodySmallStandard";
    OneStringTextStyle["numeralBodySmallEmphasize"] = "numeralBodySmallEmphasize";
    OneStringTextStyle["numeralLabelXL"] = "numeralLabelXL";
    OneStringTextStyle["numeralLabelLarge"] = "numeralLabelLarge";
    OneStringTextStyle["numeralLabelMedium"] = "numeralLabelMedium";
    OneStringTextStyle["numeralLabelSmall"] = "numeralLabelSmall";
    OneStringTextStyle["numeralCaptionLargeStandard"] = "numeralCaptionLargeStandard";
    OneStringTextStyle["numeralCaptionLargeEmphasize"] = "numeralCaptionLargeEmphasize";
    OneStringTextStyle["numeralCaptionMediumStandard"] = "numeralCaptionMediumStandard";
    OneStringTextStyle["numeralCaptionMediumEmphasize"] = "numeralCaptionMediumEmphasize";
    OneStringTextStyle["numeralCaptionSmallStandard"] = "numeralCaptionSmallStandard";
    OneStringTextStyle["numeralCaptionSmallEmphasize"] = "numeralCaptionSmallEmphasize";
})($44e73df06a2b599b$export$45a9da76fb9a91c5 || ($44e73df06a2b599b$export$45a9da76fb9a91c5 = {}));
let $44e73df06a2b599b$export$16dd9c6921e13908;
(function(OneStringAlignment) {
    OneStringAlignment["left"] = "left";
    OneStringAlignment["center"] = "center";
    OneStringAlignment["right"] = "right";
})($44e73df06a2b599b$export$16dd9c6921e13908 || ($44e73df06a2b599b$export$16dd9c6921e13908 = {}));


const $6b735e2037766ab0$var$colorMap = {
    [(0, $44e73df06a2b599b$export$9eb3b2e2bd9d0322).lead]: "text-onSurface",
    [(0, $44e73df06a2b599b$export$9eb3b2e2bd9d0322).supporting]: "text-onSurfaceVariant",
    [(0, $44e73df06a2b599b$export$9eb3b2e2bd9d0322).inverse]: "text-inverseOnSurface"
};
const $6b735e2037766ab0$var$alignmentMap = {
    [(0, $44e73df06a2b599b$export$16dd9c6921e13908).left]: "text-left",
    [(0, $44e73df06a2b599b$export$16dd9c6921e13908).center]: "text-center",
    [(0, $44e73df06a2b599b$export$16dd9c6921e13908).right]: "text-right"
};
const $6b735e2037766ab0$var$OneString = (props)=>{
    const { textStyle: textStyle , color: color = (0, $44e73df06a2b599b$export$9eb3b2e2bd9d0322).lead , alignment: alignment = (0, $44e73df06a2b599b$export$16dd9c6921e13908).left , children: children , className: className ,  } = props;
    const Tag = props.tag || "p";
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Tag, {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))(textStyle, $6b735e2037766ab0$var$colorMap[color], $6b735e2037766ab0$var$alignmentMap[alignment], className),
        children: children
    });
};
$6b735e2037766ab0$var$OneString.displayName = "OneString";
$6b735e2037766ab0$var$OneString.TextStyle = (0, $44e73df06a2b599b$export$45a9da76fb9a91c5);
$6b735e2037766ab0$var$OneString.Color = (0, $44e73df06a2b599b$export$9eb3b2e2bd9d0322);
$6b735e2037766ab0$var$OneString.Alignment = (0, $44e73df06a2b599b$export$16dd9c6921e13908);
var $6b735e2037766ab0$export$2e2bcd8739ae039 = $6b735e2037766ab0$var$OneString;



$parcel$exportWildcard($7d4e8855bbfad588$exports, $44e73df06a2b599b$exports);


var $7f5f0c94a03d2b09$exports = {};

$parcel$export($7f5f0c94a03d2b09$exports, "HeaderBody", () => $4831fc6459e167b7$export$2e2bcd8739ae039);



const $4831fc6459e167b7$var$HeaderBody = (props)=>{
    const { header: header , headerTag: headerTag = "h1" , body: body , className: className  } = props;
    const HeaderComponent = headerTag;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("header-body", className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(HeaderComponent, {
                children: header
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                children: body
            })
        ]
    });
};
$4831fc6459e167b7$var$HeaderBody.displayName = "HeaderBody";
var $4831fc6459e167b7$export$2e2bcd8739ae039 = $4831fc6459e167b7$var$HeaderBody;




var $37ff0b5a3760ba6f$exports = {};

$parcel$export($37ff0b5a3760ba6f$exports, "LegalEllipsizer", () => $e9a2c856035ecc4e$export$2e2bcd8739ae039);



var $b36917abb3daee1e$exports = {};

$parcel$export($b36917abb3daee1e$exports, "LegalString", () => $7f801c207ad01de9$export$2e2bcd8739ae039);




var $c024a653dfb14ece$exports = {};

$parcel$export($c024a653dfb14ece$exports, "LegalStringColor", () => $c024a653dfb14ece$export$8a2846743b48238d);
let $c024a653dfb14ece$export$8a2846743b48238d;
(function(LegalStringColor) {
    LegalStringColor["lead"] = "lead";
    LegalStringColor["supporting"] = "supporting";
    LegalStringColor["inverse"] = "inverse";
})($c024a653dfb14ece$export$8a2846743b48238d || ($c024a653dfb14ece$export$8a2846743b48238d = {}));


const $7f801c207ad01de9$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-legal-string", []);
const $7f801c207ad01de9$var$colorMap = {
    [(0, $c024a653dfb14ece$export$8a2846743b48238d).lead]: "text-onSurface",
    [(0, $c024a653dfb14ece$export$8a2846743b48238d).supporting]: "text-onSurfaceVariant",
    [(0, $c024a653dfb14ece$export$8a2846743b48238d).inverse]: "text-inverseOnSurface"
};
const $7f801c207ad01de9$var$LegalString = (props)=>{
    const { footnote: footnote , className: className , color: color = (0, $c024a653dfb14ece$export$8a2846743b48238d).supporting , children: children  } = props;
    const thisClassNames = (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($7f801c207ad01de9$export$ce4ab0c55987d1ff, props), $7f801c207ad01de9$var$colorMap[color], className);
    return footnote ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("li", {
        className: thisClassNames,
        value: footnote,
        children: children
    }) : /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
        className: thisClassNames,
        children: children
    });
};
$7f801c207ad01de9$var$LegalString.displayName = "LegalString";
$7f801c207ad01de9$var$LegalString.Color = (0, $c024a653dfb14ece$export$8a2846743b48238d);
var $7f801c207ad01de9$export$2e2bcd8739ae039 = $7f801c207ad01de9$var$LegalString;



$parcel$exportWildcard($b36917abb3daee1e$exports, $c024a653dfb14ece$exports);



const $e9a2c856035ecc4e$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-legal-ellipsizer", [
    "expand-button"
]);
const $e9a2c856035ecc4e$var$LegalEllipsizer = (props)=>{
    const { className: className , expandText: expandText , onExpand: onExpand , ...rest } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("button", {
        onClick: onExpand,
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($e9a2c856035ecc4e$export$ce4ab0c55987d1ff, props), className),
        type: "button",
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7f801c207ad01de9$export$2e2bcd8739ae039), {
                ...rest
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("span", {
                className: $e9a2c856035ecc4e$export$ce4ab0c55987d1ff.expandButton,
                children: [
                    "...",
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                        children: expandText
                    })
                ]
            })
        ]
    });
};
$e9a2c856035ecc4e$var$LegalEllipsizer.displayName = "LegalEllipsizer";
var $e9a2c856035ecc4e$export$2e2bcd8739ae039 = $e9a2c856035ecc4e$var$LegalEllipsizer;





var $c02962db296b0cce$exports = {};

$parcel$defineInteropFlag($c02962db296b0cce$exports);

$parcel$export($c02962db296b0cce$exports, "default", () => $5a0ad20b05b14b7a$export$2e2bcd8739ae039);




let $2dc8b4aed7e21b2e$export$f8ec6beb1c18bf0;
(function(ValidationStringVariant) {
    ValidationStringVariant["Default"] = "default";
    ValidationStringVariant["Success"] = "success";
    ValidationStringVariant["Error"] = "error";
})($2dc8b4aed7e21b2e$export$f8ec6beb1c18bf0 || ($2dc8b4aed7e21b2e$export$f8ec6beb1c18bf0 = {}));


const $5a0ad20b05b14b7a$var$variantColorMap = {
    [(0, $2dc8b4aed7e21b2e$export$f8ec6beb1c18bf0).Default]: "text-onSurfaceVariant",
    [(0, $2dc8b4aed7e21b2e$export$f8ec6beb1c18bf0).Error]: "text-error",
    [(0, $2dc8b4aed7e21b2e$export$f8ec6beb1c18bf0).Success]: "text-success"
};
const $5a0ad20b05b14b7a$var$ValidationString = (props)=>{
    const { variant: variant , children: children  } = props;
    const color = $5a0ad20b05b14b7a$var$variantColorMap[variant || (0, $2dc8b4aed7e21b2e$export$f8ec6beb1c18bf0).Default];
    const IconComponent = variant === (0, $2dc8b4aed7e21b2e$export$f8ec6beb1c18bf0).Error ? (0, $lTu3p$stashinvestreactassets.XBoldIcon) : (0, $lTu3p$stashinvestreactassets.CheckIcon);
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("validation-string", props.variant, props.className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(IconComponent, {
                size: "2XS",
                color: color
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                children: children
            })
        ]
    });
};
$5a0ad20b05b14b7a$var$ValidationString.displayName = "ValidationString";
$5a0ad20b05b14b7a$var$ValidationString.Variant = (0, $2dc8b4aed7e21b2e$export$f8ec6beb1c18bf0);
var $5a0ad20b05b14b7a$export$2e2bcd8739ae039 = $5a0ad20b05b14b7a$var$ValidationString;




var $112ee161ee8086ef$exports = {};

$parcel$export($112ee161ee8086ef$exports, "Avatar", () => $1a7e665dba49fded$export$2e2bcd8739ae039);





const $1a7e665dba49fded$var$getVariantClass = ({ type: type  })=>{
    if (type === "icon") return "variant-icon";
    else if (type === "image") return "variant-image";
    else if (type === "date") return "variant-date";
};
const $1a7e665dba49fded$var$Avatar = (props)=>{
    const { className: className , shape: shape = "square" , backgroundType: backgroundType = "fill" , variant: variant , isEnabled: isEnabled = true ,  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("sds-avatar", className, shape, backgroundType, $1a7e665dba49fded$var$getVariantClass(variant), {
            "is-disabled": !isEnabled
        }),
        children: (()=>{
            if (variant.type === "icon") {
                const { variant: iconVariant = "neutral" , size: size = "medium" , Icon: Icon  } = variant;
                const variantToTokenMap = {
                    neutral: "text-onSurface",
                    brand: "text-onPrimaryContainer",
                    error: "text-onErrorContainer",
                    success: "text-onSuccessContainer",
                    warning: "text-onWarningContainer",
                    inverse: "text-inverseOnSurface"
                };
                const IconSizeMap = {
                    small: {
                        className: "size-small",
                        iconSize: "XS"
                    },
                    medium: {
                        className: "size-medium",
                        iconSize: "small"
                    },
                    large: {
                        className: "size-large",
                        iconSize: "medium"
                    }
                };
                return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                    className: (0, ($parcel$interopDefault($lTu3p$classnames)))(iconVariant, IconSizeMap[size].className, {
                        ["opacity-opacityContent"]: !isEnabled
                    }),
                    children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Icon, {
                        size: IconSizeMap[size].iconSize,
                        color: isEnabled ? variantToTokenMap[iconVariant] : "text-onSurface"
                    })
                });
            }
            if (variant.type === "image") return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.Image), {
                className: (0, ($parcel$interopDefault($lTu3p$classnames)))({
                    "opacity-opacityContent": !isEnabled
                }),
                imageToken: variant.imageToken,
                altText: variant.altText,
                size: "medium"
            });
            if (variant.type === "date") {
                const dayOfWeek = (0, $lTu3p$datefns.format)(variant.date, "eee");
                const dayOfMonth = (0, $lTu3p$datefns.format)(variant.date, "d");
                return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)((0, $lTu3p$reactjsxruntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                            className: "top",
                            children: dayOfWeek
                        }),
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                            className: "bottom",
                            children: dayOfMonth
                        })
                    ]
                });
            }
        })()
    });
};
$1a7e665dba49fded$var$Avatar.displayName = "Avatar";
var $1a7e665dba49fded$export$2e2bcd8739ae039 = $1a7e665dba49fded$var$Avatar;




var $99ae4100857572e7$exports = {};

$parcel$export($99ae4100857572e7$exports, "Banner", () => $2a9c868252d154c7$export$2e2bcd8739ae039);




const $2a9c868252d154c7$var$Banner = (props)=>{
    const { variant: variant , className: className , onClick: onClick , maxLines: maxLines  } = props;
    const isDefaultVariant = variant.type === "default";
    const maxLineStyle = maxLines ? {
        "--numMaxLines": maxLines
    } : {};
    const Inner = /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)((0, $lTu3p$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: "graphic",
                children: isDefaultVariant ? variant.avatar : variant.illustration
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: "titles",
                children: isDefaultVariant ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                    className: "text",
                    children: variant.text
                }) : /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)((0, $lTu3p$reactjsxruntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                            className: "header",
                            children: variant.header
                        }),
                        variant.body && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                            className: "body",
                            children: variant.body
                        })
                    ]
                })
            }),
            onClick && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: "caret",
                children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.CaretRightIcon), {
                    size: "XS"
                })
            })
        ]
    });
    const fullClassName = (0, ($parcel$interopDefault($lTu3p$classnames)))("banner", className, variant.type);
    return onClick ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("button", {
        className: fullClassName,
        onClick: onClick,
        style: maxLineStyle,
        "data-testid": props["data-testid"],
        children: Inner
    }) : /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: fullClassName,
        children: Inner
    });
};
$2a9c868252d154c7$var$Banner.displayName = "Banner";
var $2a9c868252d154c7$export$2e2bcd8739ae039 = $2a9c868252d154c7$var$Banner;




var $25e203ee5a4e38dc$exports = {};

$parcel$export($25e203ee5a4e38dc$exports, "Toast", () => $c8e65a6e096f6bea$export$2e2bcd8739ae039);



const $c8e65a6e096f6bea$var$getIconColor = (variant)=>{
    switch(variant){
        case "error":
            return "text-onErrorContainer";
        case "success":
            return "text-onSuccessContainer";
        case "neutral":
        default:
            return "text-inverseOnSurface";
    }
};
const $c8e65a6e096f6bea$var$getVariantClass = (variant)=>{
    switch(variant){
        case "error":
            return "variant-error";
        case "success":
            return "variant-success";
        case "neutral":
        default:
            return "variant-neutral";
    }
};
const $c8e65a6e096f6bea$var$Toast = (props)=>{
    const { className: className , Icon: Icon , text: text , variant: variant = "neutral" , onDismiss: onDismiss  } = props;
    const [closing, setClosing] = (0, $lTu3p$react.useState)(false);
    const timeoutRef = (0, $lTu3p$react.useRef)();
    const iconColor = $c8e65a6e096f6bea$var$getIconColor(variant);
    const variantClass = $c8e65a6e096f6bea$var$getVariantClass(variant);
    const closeToast = (0, $lTu3p$react.useCallback)(()=>{
        setClosing(true);
        clearTimeout(timeoutRef.current);
        if (onDismiss) onDismiss();
    }, []);
    const handleOnClick = (e)=>{
        closeToast();
    };
    const duration = (0, $lTu3p$react.useMemo)(()=>{
        const numberOfCharacters = Array.from(text).length;
        const msPerCharacter = 50;
        const rawDuration = numberOfCharacters * msPerCharacter;
        return Math.min(Math.max(rawDuration, 2000), 7000);
    }, [
        text
    ]);
    (0, $lTu3p$react.useEffect)(()=>{
        if (!closing) {
            timeoutRef.current = setTimeout(()=>{
                closeToast();
            }, duration);
            return ()=>clearTimeout(timeoutRef.current);
        }
    }, [
        closing,
        closeToast,
        duration
    ]);
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("button", {
        onClick: handleOnClick,
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("sds-toast", className, variantClass, closing && "closing"),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Icon, {
                size: "XS",
                color: iconColor,
                className: "mr-contentXS"
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                children: text
            })
        ]
    });
};
$c8e65a6e096f6bea$var$Toast.displayName = "Toast";
var $c8e65a6e096f6bea$export$2e2bcd8739ae039 = $c8e65a6e096f6bea$var$Toast;







const $8c7efe2f666cad3d$var$CheckSelect = (props)=>{
    const { children: children , className: className , checked: checked , isEnabled: isEnabled = true , defaultChecked: defaultChecked , name: name , labelledby: labelledby , describedby: describedby , onChange: onChange ,  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("label", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("sds-check-select", className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("input", {
                type: "radio",
                "aria-labelledby": labelledby,
                "aria-describedby": describedby,
                checked: checked,
                defaultChecked: defaultChecked,
                name: name,
                disabled: !isEnabled,
                onChange: onChange
            }),
            children
        ]
    });
};
$8c7efe2f666cad3d$var$CheckSelect.displayName = "CheckSelect";
var $8c7efe2f666cad3d$export$2e2bcd8739ae039 = $8c7efe2f666cad3d$var$CheckSelect;








const $f7c6fef90cdc4b20$var$CheckSelectItem = (props)=>{
    const { className: className , children: children , ...rest } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("sds-check-select-item", className),
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $8c7efe2f666cad3d$export$2e2bcd8739ae039), {
            ...rest,
            children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                children: children
            })
        })
    });
};
$f7c6fef90cdc4b20$var$CheckSelectItem.displayName = "CheckSelectItem";
var $f7c6fef90cdc4b20$export$2e2bcd8739ae039 = $f7c6fef90cdc4b20$var$CheckSelectItem;








const $840abbb2f61fda3f$export$ce4ab0c55987d1ff = {
    base: "sds-selection-entry-button",
    isDisabled: "is-disabled",
    hasError: "has-error",
    isSelected: "is-selected",
    text: "text",
    icon: "icon",
    assistiveMessage: "assistive-message",
    label: "label",
    input: "input"
};
const $840abbb2f61fda3f$var$SelectionEntryButton = (props)=>{
    const { className: className , label: label , input: input , isEnabled: isEnabled = true , assistiveMessageText: assistiveMessageText , onClick: onClick , Icon: Icon , id: id ,  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))($840abbb2f61fda3f$export$ce4ab0c55987d1ff.base, className, {
            [$840abbb2f61fda3f$export$ce4ab0c55987d1ff.isDisabled]: !isEnabled,
            [$840abbb2f61fda3f$export$ce4ab0c55987d1ff.hasError]: isEnabled && assistiveMessageText?.type === "error"
        }),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("button", {
                type: "button",
                onClick: ()=>onClick(),
                id: id,
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                        className: $840abbb2f61fda3f$export$ce4ab0c55987d1ff.text,
                        children: [
                            label && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                                className: $840abbb2f61fda3f$export$ce4ab0c55987d1ff.label,
                                children: label
                            }),
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                                className: $840abbb2f61fda3f$export$ce4ab0c55987d1ff.input,
                                children: input
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        className: $840abbb2f61fda3f$export$ce4ab0c55987d1ff.icon,
                        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Icon, {
                            size: "XS"
                        })
                    })
                ]
            }),
            isEnabled && assistiveMessageText && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: $840abbb2f61fda3f$export$ce4ab0c55987d1ff.assistiveMessage,
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.WarningIcon), {
                            size: "2XS",
                            color: isEnabled && assistiveMessageText.type === "error" ? "text-onErrorContainer" : undefined
                        })
                    }),
                    assistiveMessageText.text
                ]
            })
        ]
    });
};
$840abbb2f61fda3f$var$SelectionEntryButton.displayName = "SelectionEntryButton";
var $840abbb2f61fda3f$export$2e2bcd8739ae039 = $840abbb2f61fda3f$var$SelectionEntryButton;







const $04a61b1b5a6a08b9$export$ce4ab0c55987d1ff = {
    base: "sds-button-choice",
    isSelected: "is-selected",
    content: "content"
};
const $04a61b1b5a6a08b9$var$ButtonChoice = (props)=>{
    const { className: className , isSelected: isSelected = false , children: children , disabled: disabled = false ,  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("button", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))($04a61b1b5a6a08b9$export$ce4ab0c55987d1ff.base, {
            [$04a61b1b5a6a08b9$export$ce4ab0c55987d1ff.isSelected]: isSelected
        }, className),
        onClick: props.onClick,
        "data-testid": props["data-testid"],
        disabled: disabled,
        type: "button",
        children: children
    });
};
$04a61b1b5a6a08b9$var$ButtonChoice.displayName = "ButtonChoice";
var $04a61b1b5a6a08b9$export$2e2bcd8739ae039 = $04a61b1b5a6a08b9$var$ButtonChoice;










const $2277a79a78966356$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-search-entry", [
    "is-enabled",
    "search-icon",
    "clear-icon",
    "has-text", 
]);
const $2277a79a78966356$var$SearchEntry = (props)=>{
    const { inputName: inputName , text: text = "" , isEnabled: isEnabled , onTextChanged: onTextChanged  } = props;
    const [internalText, setInternalText] = (0, $lTu3p$react.useState)(text);
    (0, $lTu3p$react.useEffect)(()=>{
        if (onTextChanged) onTextChanged(internalText);
    }, [
        internalText
    ]);
    (0, $lTu3p$react.useEffect)(()=>{
        setInternalText(text);
    }, [
        text
    ]);
    const hasText = internalText !== "";
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($2277a79a78966356$export$ce4ab0c55987d1ff, props), {
            [$2277a79a78966356$export$ce4ab0c55987d1ff.hasText]: hasText
        }),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("input", {
                onChange: (e)=>{
                    setInternalText(e.currentTarget.value);
                },
                value: internalText,
                placeholder: inputName,
                disabled: !isEnabled
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        className: $2277a79a78966356$export$ce4ab0c55987d1ff.searchIcon,
                        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.MagnifyingGlassIcon), {
                            size: "XS"
                        })
                    }),
                    hasText && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        className: $2277a79a78966356$export$ce4ab0c55987d1ff.clearIcon,
                        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            Icon: (0, $lTu3p$stashinvestreactassets.XBoldIcon),
                            size: "small",
                            onClick: ()=>setInternalText("")
                        })
                    })
                ]
            })
        ]
    });
};
$2277a79a78966356$var$SearchEntry.displayName = "SearchEntry";
var $2277a79a78966356$export$2e2bcd8739ae039 = $2277a79a78966356$var$SearchEntry;










const $1cb2318bc435a622$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-toolbar", [
    "variant-page",
    "variant-section",
    "left-action",
    "right-action",
    "text-content", 
]);
const $1cb2318bc435a622$var$Toolbar = (props)=>{
    const { variant: variant , header: header  } = props;
    const HeaderTag = props.tag || "div";
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($1cb2318bc435a622$export$ce4ab0c55987d1ff, props)),
        children: (()=>{
            if (variant.type === "page") {
                const { navButtonIcon: navButtonIcon , firstButtonIcon: firstButtonIcon , secondButtonIcon: secondButtonIcon  } = variant;
                return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)((0, $lTu3p$reactjsxruntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                            className: $1cb2318bc435a622$export$ce4ab0c55987d1ff.leftAction,
                            children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                                ...navButtonIcon
                            })
                        }),
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(HeaderTag, {
                            className: $1cb2318bc435a622$export$ce4ab0c55987d1ff.textContent,
                            children: header
                        }),
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                            className: $1cb2318bc435a622$export$ce4ab0c55987d1ff.rightAction,
                            children: [
                                firstButtonIcon && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                                    ...firstButtonIcon
                                }),
                                secondButtonIcon && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                                    ...secondButtonIcon
                                })
                            ]
                        })
                    ]
                });
            }
            if (variant.type === "section") {
                const { button: button , firstButtonIcon: firstButtonIcon1 , secondButtonIcon: secondButtonIcon1  } = variant;
                return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)((0, $lTu3p$reactjsxruntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(HeaderTag, {
                            className: $1cb2318bc435a622$export$ce4ab0c55987d1ff.textContent,
                            children: header
                        }),
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                            className: $1cb2318bc435a622$export$ce4ab0c55987d1ff.rightAction,
                            children: [
                                /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $aa285ef5701ee664$export$2e2bcd8739ae039), {
                                    size: "medium",
                                    variant: "secondary",
                                    onClick: button.onClick,
                                    leftIcon: button.Icon,
                                    children: button.text
                                }),
                                firstButtonIcon1 && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    ...firstButtonIcon1
                                }),
                                secondButtonIcon1 && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    ...secondButtonIcon1
                                })
                            ]
                        })
                    ]
                });
            }
        })()
    });
};
$1cb2318bc435a622$var$Toolbar.displayName = "Toolbar";
var $1cb2318bc435a622$export$2e2bcd8739ae039 = $1cb2318bc435a622$var$Toolbar;









const $b410022bb5c44f17$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-button-image", [
    "button-image", 
]);
const $b410022bb5c44f17$var$ButtonImage = (props)=>{
    const { imageToken: imageToken , isEnabled: isEnabled = true , altText: altText , onClick: onClick , label: label  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("button", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($b410022bb5c44f17$export$ce4ab0c55987d1ff, props)),
        disabled: !isEnabled,
        onClick: onClick,
        title: altText,
        "aria-label": label,
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.Image), {
            className: $b410022bb5c44f17$export$ce4ab0c55987d1ff.buttonImage,
            imageToken: imageToken,
            size: "medium"
        })
    });
};
$b410022bb5c44f17$var$ButtonImage.displayName = "ButtonImage";
var $b410022bb5c44f17$export$2e2bcd8739ae039 = $b410022bb5c44f17$var$ButtonImage;








const $5bd3fa013367827b$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-text");
const $5bd3fa013367827b$var$mapAlignmentToClass = {
    "left": "text-left",
    "center": "text-center",
    "right": "text-right"
};
const $5bd3fa013367827b$var$Text = (props)=>{
    const { className: className , children: children , textStyle: textStyle , color: color , textAlign: textAlign = "left" , overflow: overflow = false , maxLines: maxLines , tag: tag , ...rest } = props;
    const Tag = tag || "p";
    const textAlignClass = $5bd3fa013367827b$var$mapAlignmentToClass[textAlign];
    const overflowClass = overflow ? "truncate" : "";
    const maxLineClass = maxLines ? "lineClamp" : "";
    const maxLineStyle = maxLines ? {
        "--numMaxLines": maxLines
    } : {};
    const defaultClasses = "whitespace-pre-wrap" //Preserves newlines and spaces
    ;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Tag, {
        ...rest,
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($5bd3fa013367827b$export$ce4ab0c55987d1ff, props), className, defaultClasses, color, textStyle, textAlignClass, overflowClass, maxLineClass),
        style: maxLineStyle,
        children: children
    });
};
$5bd3fa013367827b$var$Text.displayName = "Text";
var $5bd3fa013367827b$export$2e2bcd8739ae039 = $5bd3fa013367827b$var$Text;









const $201c8ccc1e932409$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-radio-item", [
    "content",
    "header",
    "body"
]);
const $201c8ccc1e932409$var$mapPaddingToClassName = {
    small: "pr-contentSmall pl-content3XS",
    medium: "pr-contentMedium pl-contentXS"
};
const $201c8ccc1e932409$var$RadioItem = (props)=>{
    const { className: className , header: header , body: body , contentPadding: contentPadding = "medium" , variant: variant = {
        type: "text"
    } , ...radioProps } = props;
    function renderRightColumn() {
        if (variant.type === "text") return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
            className: "self-start flex-1",
            children: variant.rightText
        });
        else if (variant.type === "badge") return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
            children: variant.badge
        });
        return;
    }
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($201c8ccc1e932409$export$ce4ab0c55987d1ff, props), className, $201c8ccc1e932409$var$mapPaddingToClassName[contentPadding]),
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $9870ffb8643b14fb$export$2e2bcd8739ae039), {
            ...radioProps,
            children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: "label",
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                        className: $201c8ccc1e932409$export$ce4ab0c55987d1ff.content,
                        children: [
                            header && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                                className: $201c8ccc1e932409$export$ce4ab0c55987d1ff.header,
                                children: header
                            }),
                            body && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                                className: $201c8ccc1e932409$export$ce4ab0c55987d1ff.body,
                                children: body
                            })
                        ]
                    }),
                    renderRightColumn()
                ]
            })
        })
    });
};
$201c8ccc1e932409$var$RadioItem.displayName = "RadioItem";
var $201c8ccc1e932409$export$2e2bcd8739ae039 = $201c8ccc1e932409$var$RadioItem;














const $972a082621bea3b5$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-assistive-text", [
    "error-icon"
]);
const $972a082621bea3b5$var$mapVariantToColor = {
    error: "text-error",
    hint: "text-secondary"
};
const $972a082621bea3b5$var$mapAlignmentToClass = {
    left: "text-left",
    center: "text-center"
};
const $972a082621bea3b5$var$AssistiveText = (props)=>{
    const { className: className , text: text , variant: variant = "hint" , align: align = "left" , id: id  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        id: id,
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))(className, $972a082621bea3b5$var$mapAlignmentToClass[align], (0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($972a082621bea3b5$export$ce4ab0c55987d1ff, props)),
        children: [
            variant === "error" && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.WarningIcon), {
                size: "2XS",
                color: "text-error",
                className: $972a082621bea3b5$export$ce4ab0c55987d1ff.errorIcon
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $5bd3fa013367827b$export$2e2bcd8739ae039), {
                tag: "span",
                color: $972a082621bea3b5$var$mapVariantToColor[variant],
                textAlign: align,
                textStyle: "captionMediumStandard",
                children: text
            })
        ]
    });
};
$972a082621bea3b5$var$AssistiveText.displayName = "AssistiveText";
var $972a082621bea3b5$export$2e2bcd8739ae039 = $972a082621bea3b5$var$AssistiveText;




const $c02d188a4317839c$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-amount-entry-xl", [
    "input-container",
    "input-decorator",
    "input-spacer",
    "suffix",
    "suffix-container",
    "variant-currency",
    "variant-percent",
    "assistive-text", 
]);
const $c02d188a4317839c$var$showPercentStyle = {
    "--percent-display": "inline-block"
};
const $c02d188a4317839c$var$showCurrencyStyle = {
    "--currency-display": "inline-block"
};
const $c02d188a4317839c$var$AmountEntryXl = (props)=>{
    const { className: className , defaultValue: defaultValue = "0" , variant: variant , assistiveText: assistiveText  } = props;
    const [internalValue, setInternalValue] = (0, $lTu3p$react.useState)(defaultValue);
    const [suffix, setSuffix] = (0, $lTu3p$react.useState)("");
    function handleOnChange(e) {
        const val = e.currentTarget.value.replace(/[^0-9.]+/g, "");
        if (!val) {
            setInternalValue("0");
            setSuffix("");
            return;
        }
        const [_lhs, rhs] = val.toString().split(".");
        //if mantissa exists, check to determine length of suffix
        if (rhs) {
            if (rhs.length >= 2) {
                setSuffix("");
                setInternalValue(parseFloat(val).toFixed(2));
            } else if (rhs.length === 1) {
                setSuffix("0");
                setInternalValue(parseFloat(val).toFixed(1));
            }
        } else if (val.endsWith(".")) {
            setSuffix("00");
            setInternalValue(val);
        } else {
            setSuffix("");
            setInternalValue(parseInt(val));
        }
    }
    function handleOnInput(e) {
        const numRegex = /[0-9.]{1}/;
        const event = e.nativeEvent;
        // Single Character Scenario
        if (event.data?.length === 1) {
            // if invalid character, discard event
            if (!event.data.match(numRegex)) {
                e.target.value = internalValue;
                return;
            }
            if (event.data === ".") {
                //Ignore additional decimal points
                if (internalValue.toString().includes(".")) e.target.value = internalValue;
                setSuffix("00");
            }
        }
    }
    function extendOnchange(e) {
        handleOnChange(e);
        if (props.onChange) props.onChange(e);
    }
    let decoratorStyle = {};
    if (variant === "percent") decoratorStyle = $c02d188a4317839c$var$showPercentStyle;
    else if (variant === "currency") decoratorStyle = $c02d188a4317839c$var$showCurrencyStyle;
    const assistiveTextId = assistiveText && (assistiveText.id || `${props.id}-hint` || "amount-entry-id");
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($c02d188a4317839c$export$ce4ab0c55987d1ff, props), className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: $c02d188a4317839c$export$ce4ab0c55987d1ff.inputContainer,
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                        className: $c02d188a4317839c$export$ce4ab0c55987d1ff.inputDecorator,
                        style: decoratorStyle,
                        children: [
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                                className: $c02d188a4317839c$export$ce4ab0c55987d1ff.inputSpacer,
                                children: internalValue
                            }),
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                                className: $c02d188a4317839c$export$ce4ab0c55987d1ff.suffixContainer,
                                children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                                    className: $c02d188a4317839c$export$ce4ab0c55987d1ff.suffix,
                                    children: suffix
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("input", {
                        type: "tel",
                        id: props.id,
                        pattern: "[0-9.]+",
                        value: internalValue,
                        onInput: (e)=>handleOnInput(e),
                        onChange: (e)=>extendOnchange(e),
                        "aria-label": props.label,
                        "aria-invalid": assistiveText && assistiveText.variant === "error",
                        "aria-describedby": assistiveTextId
                    })
                ]
            }),
            assistiveText && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $972a082621bea3b5$export$2e2bcd8739ae039), {
                className: $c02d188a4317839c$export$ce4ab0c55987d1ff.assistiveText,
                ...assistiveText,
                ...assistiveTextId && {
                    id: assistiveTextId
                }
            })
        ]
    });
};
$c02d188a4317839c$var$AmountEntryXl.displayName = "AmountEntryXl";
var $c02d188a4317839c$export$2e2bcd8739ae039 = $c02d188a4317839c$var$AmountEntryXl;










const $e24eb9c6726cafe9$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-expand-item", [
    "header",
    "content"
]);
const $e24eb9c6726cafe9$var$mapPaddingToClassName = {
    small: "px-contentSmall py-content2XS",
    medium: "px-contentMedium py-content2XS"
};
const $e24eb9c6726cafe9$var$ExpandItem = (props)=>{
    const { className: className , children: children , header: header , contentPadding: contentPadding = "medium"  } = props;
    const [isExpanded, setExpanded] = (0, $lTu3p$react.useState)(false);
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($e24eb9c6726cafe9$export$ce4ab0c55987d1ff, props), className),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("button", {
                onClick: ()=>setExpanded(!isExpanded),
                "aria-expanded": isExpanded,
                "aria-label": `Expand ${header}`,
                children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                    className: (0, ($parcel$interopDefault($lTu3p$classnames)))($e24eb9c6726cafe9$export$ce4ab0c55987d1ff.header, $e24eb9c6726cafe9$var$mapPaddingToClassName[contentPadding]),
                    children: [
                        /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                            children: header
                        }),
                        isExpanded ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.CaretUpIcon), {
                            className: "flex-none",
                            size: "XS"
                        }) : /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.CaretDownIcon), {
                            className: "flex-none",
                            size: "XS"
                        })
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: (0, ($parcel$interopDefault($lTu3p$classnames)))($e24eb9c6726cafe9$export$ce4ab0c55987d1ff.content, $e24eb9c6726cafe9$var$mapPaddingToClassName[contentPadding]),
                children: children
            })
        ]
    });
};
$e24eb9c6726cafe9$var$ExpandItem.displayName = "ExpandItem";
var $e24eb9c6726cafe9$export$2e2bcd8739ae039 = $e24eb9c6726cafe9$var$ExpandItem;










const $1302f2f4097b68c6$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-checkbox-item", [
    "content",
    "header",
    "body",
    "legal", 
]);
const $1302f2f4097b68c6$var$mapPaddingToClassName = {
    small: "pr-contentSmall pl-content3XS",
    medium: "pr-contentMedium pl-contentXS"
};
const $1302f2f4097b68c6$var$CheckboxItem = (props)=>{
    const { className: className , header: header , body: body , contentPadding: contentPadding = "medium" , variant: variant = {
        type: "text"
    } , ...radioProps } = props;
    function renderRightColumn() {
        if (variant.type === "text") return variant.rightText && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
            className: "self-start",
            children: variant.rightText
        });
        else if (variant.type === "badge") return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
            children: variant.badge
        });
        return;
    }
    function renderContent() {
        if (variant.type === "legal") return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$reactjsxruntime.Fragment), {
            children: variant.legalString
        });
        return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)((0, $lTu3p$reactjsxruntime.Fragment), {
            children: [
                header && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                    className: $1302f2f4097b68c6$export$ce4ab0c55987d1ff.header,
                    children: header
                }),
                body && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("p", {
                    className: $1302f2f4097b68c6$export$ce4ab0c55987d1ff.body,
                    children: body
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($1302f2f4097b68c6$export$ce4ab0c55987d1ff, props), className, $1302f2f4097b68c6$var$mapPaddingToClassName[contentPadding]),
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $9d80b25d1c39de98$export$2e2bcd8739ae039), {
            ...radioProps,
            children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: "label",
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        className: (0, ($parcel$interopDefault($lTu3p$classnames)))($1302f2f4097b68c6$export$ce4ab0c55987d1ff.content, {
                            [$1302f2f4097b68c6$export$ce4ab0c55987d1ff.legal]: variant.type === "legal"
                        }),
                        children: renderContent()
                    }),
                    renderRightColumn()
                ]
            })
        })
    });
};
$1302f2f4097b68c6$var$CheckboxItem.displayName = "CheckboxItem";
var $1302f2f4097b68c6$export$2e2bcd8739ae039 = $1302f2f4097b68c6$var$CheckboxItem;









const $b19dbc5bde8e6bf8$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-chip-action", [
    "field",
    "is-selected",
    "is-loading",
    "variant-secondary", 
]);
const $b19dbc5bde8e6bf8$var$mapVariantToIconColor = {
    outline: "text-primary",
    secondary: "text-onSurface"
};
const $b19dbc5bde8e6bf8$var$ChipAction = (props)=>{
    const { className: className , text: text , variant: variant = "outline" , isDisabled: isDisabled = false , isLoading: isLoading = false , isSelected: isSelected = false , onClick: onClick , Icon: Icon , label: label ,  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("button", {
        disabled: isDisabled,
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($b19dbc5bde8e6bf8$export$ce4ab0c55987d1ff, props), `variant-${variant}`, className),
        "data-testid": props["data-testid"],
        onClick: onClick,
        "aria-label": label,
        children: [
            isLoading ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $a0133489bd20f6e5$export$2e2bcd8739ae039), {
                size: "small",
                fill: variant === "secondary" ? "onSurfaceVariant" : "primary"
            }) : /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$reactjsxruntime.Fragment), {
                children: Icon && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Icon, {
                    size: "2XS",
                    color: isDisabled ? undefined : $b19dbc5bde8e6bf8$var$mapVariantToIconColor[variant]
                })
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                children: text
            })
        ]
    });
};
$b19dbc5bde8e6bf8$var$ChipAction.displayName = "ChipAction";
var $b19dbc5bde8e6bf8$export$2e2bcd8739ae039 = $b19dbc5bde8e6bf8$var$ChipAction;









const $ce0573c37119430a$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-chip-choice", [
    "is-active",
    "is-enabled"
]);
const $ce0573c37119430a$var$ChipChoice = (props)=>{
    const { className: className , onClick: onClick , text: text , isEnabled: isEnabled = true , isActive: isActive = false , label: label  } = props;
    function renderIcon() {
        if (!isActive) return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.CaretDownBoldIcon), {
            color: isEnabled ? "text-onSurfaceVariant" : undefined,
            size: "2XS"
        });
        else return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.CaretUpBoldIcon), {
            color: isEnabled ? "text-onSurfaceVariant" : undefined,
            size: "2XS"
        });
    }
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("button", {
        disabled: !isEnabled,
        onClick: onClick,
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($ce0573c37119430a$export$ce4ab0c55987d1ff, props), className, {
            [$ce0573c37119430a$export$ce4ab0c55987d1ff.isActive]: isActive
        }),
        "data-testid": props["data-testid"],
        "aria-label": label,
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("span", {
                children: text
            }),
            renderIcon()
        ]
    });
};
$ce0573c37119430a$var$ChipChoice.displayName = "ChipChoice";
var $ce0573c37119430a$export$2e2bcd8739ae039 = $ce0573c37119430a$var$ChipChoice;












var $71fd50303ac58049$exports = {};

$parcel$export($71fd50303ac58049$exports, "SdsNavContext", () => $71fd50303ac58049$export$2aeddfba4aa335a2);
$parcel$export($71fd50303ac58049$exports, "SdsNavProvider", () => $71fd50303ac58049$export$310c996b64761a3);
$parcel$export($71fd50303ac58049$exports, "useNavContext", () => $71fd50303ac58049$export$85efb99160affd42);


const $71fd50303ac58049$export$2aeddfba4aa335a2 = /*#__PURE__*/ (0, $lTu3p$react.createContext)({
    LinkComponent: ({ children: children , to: to , ...props })=>/*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("a", {
            ...props,
            href: to,
            children: children
        })
});
function $71fd50303ac58049$export$310c996b64761a3({ children: children , linkComponent: linkComponent  }) {
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)($71fd50303ac58049$export$2aeddfba4aa335a2.Provider, {
        value: {
            LinkComponent: linkComponent
        },
        children: children
    });
}
function $71fd50303ac58049$export$85efb99160affd42() {
    return (0, $lTu3p$react.useContext)($71fd50303ac58049$export$2aeddfba4aa335a2);
}


const $b9c1f80609127d9a$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-nav-chip", [
    "container",
    "is-selected"
]);
const $b9c1f80609127d9a$var$selectedColor = "text-primary";
const $b9c1f80609127d9a$var$defaultColor = "text-onSurface";
const $b9c1f80609127d9a$var$NavChip = (props)=>{
    const { LinkComponent: Link  } = (0, $71fd50303ac58049$export$85efb99160affd42)();
    const { className: className , title: title , Icon: Icon , isSelected: isSelected , onClick: onClick , to: to , target: target  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Link, {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($b9c1f80609127d9a$export$ce4ab0c55987d1ff, props), className),
        to: to,
        onClick: onClick,
        "aria-label": `Navigate to ${title}`,
        target: target,
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
            className: $b9c1f80609127d9a$export$ce4ab0c55987d1ff.container,
            children: [
                /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Icon, {
                    size: "XS",
                    color: isSelected ? $b9c1f80609127d9a$var$selectedColor : $b9c1f80609127d9a$var$defaultColor
                }),
                title
            ]
        })
    });
};
$b9c1f80609127d9a$var$NavChip.displayName = "NavChip";
var $b9c1f80609127d9a$export$2e2bcd8739ae039 = $b9c1f80609127d9a$var$NavChip;




const $07724084de4503bf$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-rail", [
    "rail-item",
    "nav-stack",
    "stash-logo", 
]);
const $07724084de4503bf$var$Rail = (props)=>{
    const { className: className , navItems: navItems , selectedIndex: selectedIndex , onIndexSelect: onIndexSelect , onLogoClick: onLogoClick  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("nav", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($07724084de4503bf$export$ce4ab0c55987d1ff, props), className),
        "data-testid": props["data-testid"],
        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
            className: $07724084de4503bf$export$ce4ab0c55987d1ff.navStack,
            children: [
                /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                    className: (0, ($parcel$interopDefault($lTu3p$classnames)))("size-logo", $07724084de4503bf$export$ce4ab0c55987d1ff.stashLogo),
                    Icon: ()=>{
                        return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$stashinvestreactassets.StashLogo), {
                            className: $07724084de4503bf$export$ce4ab0c55987d1ff.stashLogo,
                            fill: "text-brandFill"
                        });
                    },
                    isEnabled: true,
                    onClick: onLogoClick,
                    size: "standard"
                }),
                navItems.map((itemProps, i)=>{
                    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $b9c1f80609127d9a$export$2e2bcd8739ae039), {
                        ...itemProps,
                        isSelected: selectedIndex === i,
                        onClick: ()=>{
                            onIndexSelect(i);
                            if (itemProps.onClick) itemProps.onClick();
                        }
                    }, `nav-chip-${i}`);
                })
            ]
        })
    });
};
$07724084de4503bf$var$Rail.displayName = "Rail";
var $07724084de4503bf$export$2e2bcd8739ae039 = $07724084de4503bf$var$Rail;

















const $26fd68934b809475$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-date-chip", [
    "is-selected",
    "field",
    "is-passthrough",
    "is-disabled"
]);
const $26fd68934b809475$var$DateChip = (props)=>{
    const { className: className , onClick: onClick , isSelected: isSelected = false , isDisabled: isDisabled = false , date: date  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("button", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($26fd68934b809475$export$ce4ab0c55987d1ff, props), className),
        disabled: !date || isDisabled,
        onClick: onClick,
        children: date && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
            className: (0, ($parcel$interopDefault($lTu3p$classnames)))($26fd68934b809475$export$ce4ab0c55987d1ff.field, {
                [$26fd68934b809475$export$ce4ab0c55987d1ff.isDisabled]: isDisabled,
                [$26fd68934b809475$export$ce4ab0c55987d1ff.isSelected]: isSelected
            }),
            children: date.getDate()
        })
    });
};
$26fd68934b809475$var$DateChip.displayName = "DateChip";
var $26fd68934b809475$export$2e2bcd8739ae039 = $26fd68934b809475$var$DateChip;




const $aa33fb4fac1ec1e0$export$1027b72e642b1e14 = [
    "SUN",
    "MON",
    "TUE",
    "WED",
    "THU",
    "FRI",
    "SAT"
];
const $aa33fb4fac1ec1e0$export$9728a3b0802da70d = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec", 
];



const $c4d0ab4f772c52a7$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-date-picker-calendar", [
    "calendar-field",
    "day-field",
    "top-bar",
    "top-bar-left",
    "top-bar-right",
    "chip-picker",
    "year-picker",
    "size-large", 
]);
const $c4d0ab4f772c52a7$export$9d17ed593ee0464d = new Date(1970, 1, 1);
const $c4d0ab4f772c52a7$export$c6ffa3413e4f033f = new Date(2999, 1, 1);
const $c4d0ab4f772c52a7$var$normalizeToMidnight = (date, newDay)=>{
    const newDate = new Date(date);
    const year = newDate.getFullYear();
    const month = newDate.getMonth();
    const day = newDay ?? newDate.getDate();
    return new Date(year, month, day);
};
const $c4d0ab4f772c52a7$var$getFirstDayOfMonth = (date)=>{
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
};
const $c4d0ab4f772c52a7$var$getDaysInMonth = (date)=>{
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};
const $c4d0ab4f772c52a7$var$adjustDateMonth = (date, num)=>{
    return new Date(date.getFullYear(), date.getMonth() + num, 1);
};
//renders empty blocks to offset calendar start day
function $c4d0ab4f772c52a7$var$renderPassThrough(date) {
    const firstDayOfMonth = $c4d0ab4f772c52a7$var$getFirstDayOfMonth(date);
    const passThroughs = [
        ...Array(firstDayOfMonth).keys()
    ];
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$reactjsxruntime.Fragment), {
        children: passThroughs.map((i)=>/*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $26fd68934b809475$export$2e2bcd8739ae039), {}, `passthrough-${i}`))
    });
}
function $c4d0ab4f772c52a7$var$renderDays({ visibleDate: visibleDate , minDate: minDate , maxDate: maxDate , onClick: onClick , selectedDate: selectedDate , variant: variant  }) {
    const daysInMonth = $c4d0ab4f772c52a7$var$getDaysInMonth(visibleDate);
    const dayChips = [
        ...Array(daysInMonth).keys()
    ];
    const normSelectedDate = selectedDate ? $c4d0ab4f772c52a7$var$normalizeToMidnight(selectedDate) : undefined;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$reactjsxruntime.Fragment), {
        children: dayChips.map((day)=>{
            const chipDate = new Date(visibleDate.getFullYear(), visibleDate.getMonth(), day + 1);
            return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $26fd68934b809475$export$2e2bcd8739ae039), {
                date: chipDate,
                isDisabled: chipDate < minDate || chipDate > maxDate,
                isSelected: !!normSelectedDate && normSelectedDate.getTime() === chipDate.getTime(),
                onClick: ()=>onClick(chipDate)
            }, `day-${day}`);
        })
    });
}
function $c4d0ab4f772c52a7$var$renderMonthPicker({ visibleDate: visibleDate , minDate: minDate , maxDate: maxDate , onClick: onClick  }) {
    minDate.setDate(0);
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: $c4d0ab4f772c52a7$export$ce4ab0c55987d1ff.chipPicker,
        children: (0, $aa33fb4fac1ec1e0$export$9728a3b0802da70d).map((monthLabel, i)=>{
            const newDate = new Date(visibleDate);
            newDate.setMonth(i);
            return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $b19dbc5bde8e6bf8$export$2e2bcd8739ae039), {
                text: monthLabel,
                variant: "secondary",
                isDisabled: newDate < minDate || newDate > maxDate,
                isSelected: visibleDate.getMonth() === i,
                onClick: ()=>{
                    onClick(newDate);
                }
            }, `month-picker-${monthLabel}`);
        })
    });
}
function $c4d0ab4f772c52a7$var$renderYearPicker({ visibleDate: visibleDate , minDate: minDate , maxDate: maxDate , onClick: onClick  }) {
    const yearArr = Array.from({
        length: maxDate.getFullYear() - minDate.getFullYear() + 1
    }, (_, i)=>minDate.getFullYear() + i);
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))($c4d0ab4f772c52a7$export$ce4ab0c55987d1ff.chipPicker, $c4d0ab4f772c52a7$export$ce4ab0c55987d1ff.yearPicker),
        children: yearArr.map((year, i)=>{
            const newDate = new Date(visibleDate);
            newDate.setFullYear(year);
            return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $b19dbc5bde8e6bf8$export$2e2bcd8739ae039), {
                text: year,
                variant: "secondary",
                isSelected: visibleDate.getFullYear() === year,
                onClick: ()=>{
                    onClick(newDate);
                }
            }, `year-picker-${year}`);
        })
    });
}
const $c4d0ab4f772c52a7$var$DatePickerCalendar = (props)=>{
    const { className: className , visibleDate: visibleDate = new Date() , selectedDate: selectedDate , minDate: minDate = $c4d0ab4f772c52a7$export$9d17ed593ee0464d , maxDate: maxDate = $c4d0ab4f772c52a7$export$c6ffa3413e4f033f , variant: variant , size: size = "small" , onFilterClicked: onFilterClicked , onNextMonthButtonClicked: onNextMonthButtonClicked , onPreviousMonthButtonClicked: onPreviousMonthButtonClicked , onDayClicked: onDayClicked ,  } = props;
    const normVisibleDate = $c4d0ab4f772c52a7$var$normalizeToMidnight(visibleDate, 1);
    const normMinDate = $c4d0ab4f772c52a7$var$normalizeToMidnight(minDate);
    const normMaxDate = $c4d0ab4f772c52a7$var$normalizeToMidnight(maxDate);
    const [activePickerType, setActivePickerType] = (0, $lTu3p$react.useState)("none");
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($c4d0ab4f772c52a7$export$ce4ab0c55987d1ff, props), className, {
            [$c4d0ab4f772c52a7$export$ce4ab0c55987d1ff.sizeLarge]: props.size === "large"
        }),
        "data-testid": props["data-testid"],
        "aria-label": props["aria-label"],
        // eslint-disable-next-line jsx-a11y/aria-props
        "data-min": (0, $lTu3p$datefns.format)(minDate, "yyyy-MM-dd"),
        "data-max": (0, $lTu3p$datefns.format)(maxDate, "yyyy-MM-dd"),
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: $c4d0ab4f772c52a7$export$ce4ab0c55987d1ff.topBar,
                children: [
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                        className: $c4d0ab4f772c52a7$export$ce4ab0c55987d1ff.topBarLeft,
                        children: [
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $ce0573c37119430a$export$2e2bcd8739ae039), {
                                text: (0, $aa33fb4fac1ec1e0$export$9728a3b0802da70d)[normVisibleDate.getMonth()],
                                isActive: activePickerType === "month",
                                onClick: ()=>{
                                    setActivePickerType(activePickerType === "month" ? "none" : "month");
                                },
                                label: "Select Month"
                            }),
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $ce0573c37119430a$export$2e2bcd8739ae039), {
                                text: normVisibleDate.getFullYear(),
                                isActive: activePickerType === "year",
                                onClick: ()=>{
                                    setActivePickerType(activePickerType === "year" ? "none" : "year");
                                },
                                label: "Select Year"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                        className: $c4d0ab4f772c52a7$export$ce4ab0c55987d1ff.topBarRight,
                        children: [
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                                label: "Previous month",
                                Icon: (0, $lTu3p$stashinvestreactassets.CaretLeftBoldIcon),
                                size: "small",
                                variant: "secondary",
                                onClick: ()=>{
                                    const newDate = $c4d0ab4f772c52a7$var$adjustDateMonth(normVisibleDate, -1);
                                    onPreviousMonthButtonClicked(newDate);
                                }
                            }),
                            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                                label: "Next month",
                                Icon: (0, $lTu3p$stashinvestreactassets.CaretRightBoldIcon),
                                size: "small",
                                variant: "secondary",
                                onClick: ()=>{
                                    const newDate = $c4d0ab4f772c52a7$var$adjustDateMonth(normVisibleDate, 1);
                                    onNextMonthButtonClicked(newDate);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                className: $c4d0ab4f772c52a7$export$ce4ab0c55987d1ff.dayField,
                children: (0, $aa33fb4fac1ec1e0$export$1027b72e642b1e14).map((day)=>{
                    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        children: day
                    }, day);
                })
            }),
            activePickerType === "month" && $c4d0ab4f772c52a7$var$renderMonthPicker({
                visibleDate: normVisibleDate,
                minDate: normMinDate,
                maxDate: normMaxDate,
                onClick: (newDate)=>{
                    onFilterClicked(newDate);
                    setActivePickerType("none");
                }
            }),
            activePickerType === "year" && $c4d0ab4f772c52a7$var$renderYearPicker({
                visibleDate: normVisibleDate,
                minDate: normMinDate,
                maxDate: normMaxDate,
                onClick: (newDate)=>{
                    setActivePickerType("none");
                    onFilterClicked(newDate);
                }
            }),
            activePickerType === "none" && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
                className: $c4d0ab4f772c52a7$export$ce4ab0c55987d1ff.calendarField,
                children: [
                    $c4d0ab4f772c52a7$var$renderPassThrough(normVisibleDate),
                    $c4d0ab4f772c52a7$var$renderDays({
                        visibleDate: normVisibleDate,
                        minDate: normMinDate,
                        maxDate: normMaxDate,
                        onClick: onDayClicked,
                        selectedDate: selectedDate,
                        variant: variant
                    })
                ]
            })
        ]
    });
};
$c4d0ab4f772c52a7$var$DatePickerCalendar.displayName = "DatePickerCalendar";
var $c4d0ab4f772c52a7$export$2e2bcd8739ae039 = $c4d0ab4f772c52a7$var$DatePickerCalendar;







var $bbadcb2501c3c18f$exports = {};

$parcel$export($bbadcb2501c3c18f$exports, "FormikTextEntryXl", () => $bbadcb2501c3c18f$export$35006fcb1a044882);
$parcel$export($bbadcb2501c3c18f$exports, "TextEntryXl", () => $f5c99f1d25a03f7e$export$2e2bcd8739ae039);










const $f5c99f1d25a03f7e$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-text-entry-xl", [
    "has-error",
    "size-large",
    "currency-prefix",
    "hide-currency-prefix",
    "input-container",
    "input-decorator",
    "input-spacer", 
]);
const $f5c99f1d25a03f7e$var$TextEntryXl = (props)=>{
    const { className: className , errorMessage: errorMessage , value: value , fieldType: fieldType = "simple" , inputType: inputType = "shortText" , type: type = "text" , onConceal: onConceal , onChange: onChange , currencyMaskOptions: currencyMaskOptions , size: size = "default" , ...rest } = props;
    // determine input component (masked or regular)
    const inputMask = inputType ? (0, $00debe9b1e22cfd5$export$2e2bcd8739ae039)(inputType, currencyMaskOptions) : undefined;
    // determine if input conceal icon should render
    const isSensitiveField = fieldType === "sensitive" || type === "password";
    const isSizeLarge = size === "large";
    // determine if input should be concealed or not
    const [concealInput, setConcealInput] = (0, $lTu3p$react.useState)(isSensitiveField);
    function handleConcealClick() {
        setConcealInput(!concealInput);
        if (typeof onConceal === "function") onConceal(!concealInput);
    }
    const assistiveTextId = errorMessage && `${props.id}-hint` || "text-entry-id";
    const commonInputProps = {
        type: isSensitiveField ? concealInput ? "password" : "text" : type,
        value: value,
        onChange: onChange,
        placeholder: props.placeholder ?? props.label,
        ...errorMessage && {
            ["aria-invalid"]: true
        },
        ...errorMessage && {
            ["aria-describedby"]: assistiveTextId
        },
        ...rest
    };
    const [showPrefix, setShowPrefix] = (0, $lTu3p$react.useState)(inputType === "currency" && (value === "" || value === null || value === undefined));
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($f5c99f1d25a03f7e$export$ce4ab0c55987d1ff, props), className),
        "data-testid": props["data-testid"],
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("label", {
                className: (0, ($parcel$interopDefault($lTu3p$classnames)))({
                    hasError: errorMessage,
                    sensitive: isSensitiveField,
                    sizeLarge: isSizeLarge
                }),
                children: [
                    showPrefix && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                        className: $f5c99f1d25a03f7e$export$ce4ab0c55987d1ff.inputDecorator,
                        children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
                            className: $f5c99f1d25a03f7e$export$ce4ab0c55987d1ff.inputSpacer,
                            children: isSizeLarge && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $lTu3p$reactjsxruntime.Fragment), {
                                children: props.placeholder
                            })
                        })
                    }),
                    inputMask ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, ($parcel$interopDefault($lTu3p$reacttextmask))), {
                        ...commonInputProps,
                        showMask: true,
                        guide: false,
                        mask: inputMask,
                        value: value,
                        onChange: (e)=>{
                            const { value: targetValue  } = e.target;
                            setShowPrefix(inputType === "currency" && (targetValue === "" || targetValue === null || targetValue === undefined));
                            if (onChange) onChange(e);
                        }
                    }) : /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("input", {
                        ...commonInputProps
                    }),
                    Boolean(isSensitiveField) ? /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $7b54d821c3bd1415$export$2e2bcd8739ae039), {
                        onClick: handleConcealClick,
                        Icon: concealInput ? (0, $lTu3p$stashinvestreactassets.EyeIcon) : (0, $lTu3p$stashinvestreactassets.EyeSlashIcon)
                    }) : null
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $972a082621bea3b5$export$2e2bcd8739ae039), {
                id: assistiveTextId,
                variant: "error",
                text: errorMessage
            })
        ]
    });
};
$f5c99f1d25a03f7e$var$TextEntryXl.displayName = "TextEntryXl";
var $f5c99f1d25a03f7e$export$2e2bcd8739ae039 = $f5c99f1d25a03f7e$var$TextEntryXl;


const $bbadcb2501c3c18f$export$35006fcb1a044882 = (0, $824ac643efa79f45$export$3d9d5005a7ef589)((0, $f5c99f1d25a03f7e$export$2e2bcd8739ae039));


$parcel$exportWildcard($8f0cabe9d646f134$exports, $c60dcc067ac8bcae$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $82b4fea781088685$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $0b55ea58065af7ac$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $78f617b04b41d203$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $7d629b70e7261af1$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $f31f8d60604045c3$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $4dde96c5bace9e4c$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $730b44557d7ae177$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $7d4e8855bbfad588$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $7f5f0c94a03d2b09$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $37ff0b5a3760ba6f$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $b36917abb3daee1e$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $c02962db296b0cce$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $112ee161ee8086ef$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $99ae4100857572e7$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $25e203ee5a4e38dc$exports);
$parcel$exportWildcard($8f0cabe9d646f134$exports, $bbadcb2501c3c18f$exports);


var $a8a3b9a0e9b33b2a$exports = {};

$parcel$export($a8a3b9a0e9b33b2a$exports, "Table", () => $822d115bfae9bc30$export$2e2bcd8739ae039);
$parcel$export($a8a3b9a0e9b33b2a$exports, "DateAvatar", () => $59a9f3168d633c55$export$2e2bcd8739ae039);
$parcel$export($a8a3b9a0e9b33b2a$exports, "DatePickerCalendarPartialSheet", () => $bc71859aa8d521e9$export$2e2bcd8739ae039);





const $822d115bfae9bc30$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-table", [
    "bottom-divider",
    "col-selected", 
]);
const $822d115bfae9bc30$var$Table = (props)=>{
    const { className: className , tableId: tableId , tableAriaLabel: tableAriaLabel , headerRow: headerRow , contentRows: contentRows , selectedColumn: selectedColumn  } = props;
    const tableKey = tableId.replace(/\s/g, "");
    const getHeaderRow = (headerRow)=>headerRow && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("thead", {
            children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("tr", {
                className: `${headerRow.isDividerHidden ? "" : $822d115bfae9bc30$export$ce4ab0c55987d1ff.bottomDivider} h-[3.5rem]`,
                children: headerRow.columns.map((col, c)=>getHeaderColumn(col, 0, c))
            })
        });
    const getHeaderColumn = (col, rowIdx, colIdx)=>/*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("th", {
            className: "captionSmallEmphasize rounded-t-lg",
            scope: "col",
            children: col.text
        }, `${tableKey}HeaderRow${rowIdx}Column${colIdx}`);
    const getColGroup = (range)=>{
        return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("colgroup", {
            children: Array.from({
                length: range
            }, (v, i)=>{
                let classes = i === selectedColumn ? $822d115bfae9bc30$export$ce4ab0c55987d1ff.colSelected : "";
                if (i !== 0) classes += " w-[30%]";
                return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("col", {
                    className: classes
                }, `${tableKey}ColGroupCol${i}`);
            })
        });
    };
    const getContentRows = (contentRows)=>contentRows?.map((row, r)=>/*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("tr", {
                className: `${row.isDividerHidden ? "" : $822d115bfae9bc30$export$ce4ab0c55987d1ff.bottomDivider} h-[3.5rem]`,
                children: row.columns.map((col, c)=>getContentColumn(col, r, c, r === contentRows.length - 1))
            }, `${tableKey}ContentRow${r}`));
    const getContentColumn = (col, rowIdx, colIdx, isLastRow)=>{
        const classes = `bodySmallStandard ${isLastRow ? " rounded-b-lg" : ""}`;
        const key = `${tableKey}ContentRow${rowIdx}Column${colIdx}`;
        if (col.icon) {
            const Icon = (0, $lTu3p$stashinvestreactassets.iconTokensMap)[col.icon].component;
            return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("td", {
                className: classes,
                children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)(Icon, {
                    size: "XS"
                })
            }, key);
        } else return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("td", {
            className: classes,
            children: col.text
        }, key);
    };
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("table", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($822d115bfae9bc30$export$ce4ab0c55987d1ff, props), className),
        "aria-label": tableAriaLabel,
        children: [
            getColGroup(Math.max(headerRow?.columns.length || 0, contentRows?.[0].columns.length || 0)),
            getHeaderRow(headerRow),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("tbody", {
                children: getContentRows(contentRows)
            })
        ]
    });
};
$822d115bfae9bc30$var$Table.displayName = "Table";
var $822d115bfae9bc30$export$2e2bcd8739ae039 = $822d115bfae9bc30$var$Table;










const $59a9f3168d633c55$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-date-avatar", [
    "variant-year"
]);
const $59a9f3168d633c55$var$DateAvatar = (props)=>{
    const { className: className , date: date , variant: variant = "month"  } = props;
    const dateObj = date ? new Date(date) : new Date();
    let topLabel;
    let bottomLabel;
    switch(variant){
        case "year":
            topLabel = (0, $aa33fb4fac1ec1e0$export$9728a3b0802da70d)[dateObj.getMonth()];
            bottomLabel = dateObj.getFullYear();
            break;
        case "day":
            topLabel = (0, $aa33fb4fac1ec1e0$export$1027b72e642b1e14)[dateObj.getDay()];
            bottomLabel = dateObj.getDate();
            break;
        case "month":
        default:
            topLabel = (0, $aa33fb4fac1ec1e0$export$9728a3b0802da70d)[dateObj.getMonth()];
            bottomLabel = dateObj.getDate();
            break;
    }
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($59a9f3168d633c55$export$ce4ab0c55987d1ff, props), className),
        "data-testid": props["data-testid"],
        children: [
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $5bd3fa013367827b$export$2e2bcd8739ae039), {
                textStyle: "labelXSStandard",
                children: topLabel
            }),
            /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $5bd3fa013367827b$export$2e2bcd8739ae039), {
                textStyle: variant === "year" ? "labelSmallEmphasize" : "labelMediumEmphasize",
                children: bottomLabel
            })
        ]
    });
};
$59a9f3168d633c55$var$DateAvatar.displayName = "DateAvatar";
var $59a9f3168d633c55$export$2e2bcd8739ae039 = $59a9f3168d633c55$var$DateAvatar;











const $bc71859aa8d521e9$export$ce4ab0c55987d1ff = (0, $866f0fa8140c50df$export$18505e447a7bb2d5)("sds-date-picker-calendar-partial-sheet", []);
/**
 * ## Usage
 * `DatePickerCalendarPartialSheet` integrates a datepicker into a partial sheet which
 * is invoked by a button.
 * The button will typically render the value of the selected date.
 * For maximum flexibility the rendering of the button is the responsibility of the consumer via a children render prop.
 *
 * example:
 *
 * ```jsx
 * <DatePickerCalendarPartialSheet
 *			value={value}
 *			onDayClicked={(newValue) => setValue(newValue)}
 *		>
 *			{(value, handleDateValueClick) => (
 *				<button onClick={handleDateValueClick}>{value.toDateString()}</button>
 *			)}
 *		</DatePickerCalendarPartialSheet>
 *
 * ```
 *
 * @param props
 * @returns
 */ const $bc71859aa8d521e9$var$DatePickerCalendarPartialSheet = (props)=>{
    const { visibleDate: initialVisibleDate , value: value , className: className , children: children , size: size , variant: variant , minDate: minDate = (0, $c4d0ab4f772c52a7$export$9d17ed593ee0464d) , maxDate: maxDate = (0, $c4d0ab4f772c52a7$export$c6ffa3413e4f033f) , onDayClicked: onDayClicked ,  } = props;
    const [visibleDate, setVisibleDate] = (0, $lTu3p$react.useState)(initialVisibleDate);
    const [showPartialSheet, setShowPartialSheet] = (0, $lTu3p$react.useState)(false);
    const handleDateValueClick = ()=>{
        setVisibleDate(initialVisibleDate);
        setShowPartialSheet(true);
    };
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsxs)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))((0, $866f0fa8140c50df$export$5cc9199cd6cdbe3b)($bc71859aa8d521e9$export$ce4ab0c55987d1ff, props), className),
        "data-testid": props["data-testid"],
        children: [
            typeof children === "function" && children(value, handleDateValueClick),
            showPartialSheet && /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $4e62b14169024d2d$export$2e2bcd8739ae039), {
                onClose: ()=>setShowPartialSheet(false),
                children: /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)((0, $c4d0ab4f772c52a7$export$2e2bcd8739ae039), {
                    "aria-label": "Date picker",
                    size: size,
                    variant: variant,
                    minDate: minDate,
                    maxDate: maxDate,
                    selectedDate: value,
                    visibleDate: visibleDate,
                    onNextMonthButtonClicked: (date)=>{
                        setVisibleDate(date);
                    },
                    onPreviousMonthButtonClicked: (date)=>{
                        setVisibleDate(date);
                    },
                    onFilterClicked: (date)=>{
                        setVisibleDate(date);
                    },
                    onDayClicked: (d)=>{
                        onDayClicked(d);
                        setShowPartialSheet(false);
                    }
                })
            })
        ]
    });
};
$bc71859aa8d521e9$var$DatePickerCalendarPartialSheet.displayName = "DatePickerCalendarPartialSheet";
var $bc71859aa8d521e9$export$2e2bcd8739ae039 = $bc71859aa8d521e9$var$DatePickerCalendarPartialSheet;






var $fb33e9953c91237a$exports = {};

$parcel$export($fb33e9953c91237a$exports, "TextSimple", () => $adfb5ca80896abfd$export$2e2bcd8739ae039);
$parcel$export($fb33e9953c91237a$exports, "Legal", () => $89ddf1c6145824a0$export$2e2bcd8739ae039);



const $adfb5ca80896abfd$var$TextSimple = (props)=>{
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("div", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("text-simple", props.className),
        children: props.children
    });
};
$adfb5ca80896abfd$var$TextSimple.displayName = "TextSimple";
var $adfb5ca80896abfd$export$2e2bcd8739ae039 = $adfb5ca80896abfd$var$TextSimple;








const $89ddf1c6145824a0$var$Legal = (props)=>{
    const { hasFootnote: hasFootnote , className: className , children: children  } = props;
    return /*#__PURE__*/ (0, $lTu3p$reactjsxruntime.jsx)("ol", {
        className: (0, ($parcel$interopDefault($lTu3p$classnames)))("layout-information-legal", {
            hasFootnote: hasFootnote
        }, className),
        children: children
    });
};
$89ddf1c6145824a0$var$Legal.displayName = "Legal";
$89ddf1c6145824a0$var$Legal.String = (0, $7f801c207ad01de9$export$2e2bcd8739ae039);
var $89ddf1c6145824a0$export$2e2bcd8739ae039 = $89ddf1c6145824a0$var$Legal;







$parcel$exportWildcard(module.exports, $8f0cabe9d646f134$exports);
$parcel$exportWildcard(module.exports, $a8a3b9a0e9b33b2a$exports);
$parcel$exportWildcard(module.exports, $fb33e9953c91237a$exports);
$parcel$exportWildcard(module.exports, $71fd50303ac58049$exports);


//# sourceMappingURL=index.js.map
